import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  InputAdornment,
  Skeleton,
  TextField,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
  CircularProgress,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  Menu,
  Collapse,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as AddIcon } from "Assets/Icons/AddIcon.svg";
import { ReactComponent as SearchIcon } from "Assets/Icons/SearchIcon.svg";
import { ReactComponent as CreateNewRxOrder } from "Assets/Icons/CreateNewRxOrder.svg";
import { ReactComponent as CopyCocumentIcon } from "Assets/Icons/PharmsmartIcon/CollectionList.svg";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import { connect, useSelector } from "react-redux";
import {
  START_GET_COLLECTION_LIST,
  START_DELETE_COLLECTION,
  RESET_COLLECTION_STATE,
  START_GET_COLLECTION_COUNT,
  START_GET_COLLECTION_DETAIL,
  START_ADD_AND_UPDATE_NOTE,
  START_DELETE_NOTE,
  START_CREATE_CHASEUP,
  START_GET_PRINT_COLLECTION_LIST,
  START_ARCHIVE_COLLECTION,
} from "Actions/CollectionAction";
import { useIntersection } from "Hooks/customHooks";
import _ from "underscore";
import { abbreviateNumber } from "utils/generalUtils";
import clsx from "clsx";
import {
  getClearObject,
  getLocalStorage,
  setLocalStorage,
  getNewOrder,
} from "utils/generalUtils";
import {
  START_ARCHIVE_MEDICATION,
  START_GET_PATIENT_LIST,
  START_GET_PATIENT_MEDICATION_HISTORY_LIST,
  START_GET_SINGLE_PATIENT,
} from "Actions/PatientAction";
import { START_UPDATE_GLOBAL_SETTING } from "Actions/RepeatOrderAction";
import { useNavigate, useLocation } from "react-router-dom";
import useHeaderPharmacySelection from "Hooks/useHeaderPharmacySelection";
import { ReactComponent as FilterIcon } from "Assets/Icons/FilterIcon.svg";
import SearchAndFilterDialogCollectionMobileView from "./SearchAndFilterDialogCollectionMobileView";
import "../../Sass/Common.scss";
import HtmlTooltipMain from "Components/Common/HtmlTooltipMain";
import UnCollectedTable from "Components/Collection/UnCollectedTable";
import PrescriptionTrackingBanners from "Components/Collection/PrescriptionTrackingBanners";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import Button from "Components/Common/Button/Button";
import { ReactComponent as PrintIcon } from "Assets/Icons/printIcon.svg";
import InfomationDialog from "Components/RepeatOrder/InfomationDialog";
import { ReactComponent as SettingIcon } from "Assets/Icons/SettingsIcon.svg";
import TableColumnShowMenu from "../Common/Table/TableColumnShowMenu";
import useViewport from "Hooks/useViewport";
import { START_GET_HOME_LIST } from "Actions/HomeAction";
import { ReactComponent as ArchiveIcon } from "Assets/Icons/ArchiveIcon.svg";
import HtmlTooltip from "Components/Common/HtmlTooltipMain";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import EditDobDialog from "Components/Patients/EditDobDialog";
import ViewOrderDialog from "Components/Common/Dialog/ViewOrderDialog";
import FaxDialog from "Components/Common/Dialog/FaxDialog";
import PatientDetailDialog from "Components/Patients/PatientDetailDialog";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckIcon from "@mui/icons-material/Check";
import SubscriptionWaringDailog from "Components/Common/Dialog/SubscriptionWaringDailog";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import { ReactComponent as ModalCloseIcon } from "Assets/Icons/PharmsmartIcon/ModalCloseIcon.svg";
// const SurgeryAutoComplete = React.lazy(() =>
//   import("Components/Patients/SurgeryAutoComplete")
// );
import SurgeryAutoComplete from "Components/Patients/SurgeryAutoComplete";
import GroupAutoComplete from "Components/Patients/GroupAutoComplete";
const DaysSettingDialog = React.lazy(() => import("./DaysSettingDialog"));
const CollectedTable = React.lazy(() =>
  import("Components/Collection/CollectedTable")
);
const PrintCollection = React.lazy(() =>
  import("Components/Collection/PrintCollection")
);
const AddAndUpdateNoteDialog = React.lazy(() =>
  import("Components/Collection/AddAndUpdateNoteDialog")
);
const CollectionNotesDialog = React.lazy(() =>
  import("Components/Collection/CollectionNotesDialog")
);
const ViewRxDialog = React.lazy(() =>
  import("Components/Collection/ViewRxDialog")
);
const ConfirmationDialog = React.lazy(() =>
  import("Components/Common/Dialog/ConfirmationDialog")
);
// const GroupAutoComplete = React.lazy(() =>
//   import("Components/Patients/GroupAutoComplete")
// );

const useStyle = makeStyles((theme) => ({
  rsCollectionHeader: {
    display: "flex",
    "&>button": {
      whiteSpace: "nowrap",
      marginTop: "3px",
      marginLeft: "10px",
      height: "37px !important",
      [theme.breakpoints.down("768")]: {
        marginLeft: "0px",
      },
    },
    "&>div": {
      marginTop: "2px",
      marginLeft: "5px",
      width: "200px",
      height: "37px !important",
      [theme.breakpoints.down("1301")]: {
        width: "unset",
        marginTop: "0px",
        marginLeft: "0px",
        marginRight: "0px",
      },
      [theme.breakpoints.down(1600)]: {
        // minWidth: "184px !important",
      },
      "&>div": {
        marginTop: "0px",
        height: "37px !important",
        "&>div": {
          height: "37px !important",
        },
      },
    },
    "&>div:nth-child(1)": {
      [theme.breakpoints.down("1301")]: {
        width: "unset",
        marginTop: "0px",
        marginLeft: "0px",
        marginRight: "10px",
      },
    },
    "&>div:nth-child(2)": {
      [theme.breakpoints.down("1301")]: {
        width: "unset",
        marginTop: "0px",
        marginLeft: "0px",
        marginRight: "3px",
      },
    },
    [theme.breakpoints.down("1145")]: {
      display: "flex !important",
      justifyContent: "space-between !important",
      width: "100%",
      marginTop: "5px",
    },
  },
  rsCollectionHeaderArchive: {
    marginTop: "-39px",
    marginBottom: "24px",
    display: "flex",
    justifyContent: "end",
    height: "37px",
    [theme.breakpoints.down("1230")]: {
      display: "none",
    },
    [theme.breakpoints.down("1230")]: {
      marginTop: "-45px",
    },
    [theme.breakpoints.down("1200")]: {
      marginRight: "17px",
    },
    "&>button": {
      marginTop: "3px",
      marginLeft: "20px",
      height: "37px !important",
      // [theme.breakpoints.down("768")]: {
      //   display: "none",
      // },
      [theme.breakpoints.down("1200")]: {
        marginTop: "0px",
      },
    },
    "&>div": {
      marginTop: "2px",
      marginLeft: "5px",
      width: "200px",
      height: "37px !important",
      [theme.breakpoints.down("1200")]: {
        display: "none",
      },
      [theme.breakpoints.up("1301")]: {
        display: "block",
      },
      [theme.breakpoints.down(1600)]: {
        minWidth: "184px !important",
      },
      "&>div": {
        height: "37px !important",
        "&>div": {
          height: "37px !important",
        },
      },
    },
  },
  rsCollection: {
    display: "flex",
    height: "37px !important",
    "&>button": {
      minWidth: "40px",
      padding: "8px !important",
      height: "37px !important",
      width: "101px !important",
    },
    [theme.breakpoints.down("1145")]: {
      display: "flex !important",
      justifyContent: "space-between !important",
      width: "100%",
    },
  },
  rsCollectionTab: {
    display: "flex",
    justifyContent: "start",
    "&>button": {
      height: "37px !important",
    },
    "&>div": {
      width: "200px",
    },

    [theme.breakpoints.down("1200")]: {
      // padding: "18px !important",
      // marginTop: "-10px",
    },
    // [theme.breakpoints.down("768")]: {
    //   padding: "18px !important",
    // },
    // [theme.breakpoints.down("769")]: {
    //   marginTop: "-35px",
    // },
    [theme.breakpoints.down("409")]: {
      justifyContent: "space-between !important",
      width: "100%",
    },
  },
  rsCollectionTabBtn: {
    whiteSpace: "nowrap !important",
    borderRadius: "5px !important",
    marginRight: "10px !important",
    fontSize: "14px  !important",
    height: "37px !important",

    backgroundColor: `${theme.palette.white.main} !important`,
    [theme.breakpoints.down("500")]: {
      fontSize: "12px  !important",
    },
    [theme.breakpoints.down("400")]: {
      fontSize: "11px  !important",
    },
    [theme.breakpoints.down("409")]: {
      marginRight: "0px !important",
    },
    color: `${theme.palette.secondary.main} !important`,
    "&>h6": {
      background: "rgba(90, 104, 114, 0.1)",
      border: `0.5px solid ${theme.palette.secondary.main}`,
      height: "20px",
      width: "35px",
      borderRadius: "2px",
      paddingRight: "-5px",
      color: `${theme.palette.secondary.main} !important`,
      // [theme.breakpoints.down("768")]: {
      //   width: "33px",
      // },
      [theme.breakpoints.down("400")]: {
        width: "32px !important",
      },
    },
  },
  rsActiveButton: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.white.main} !important`,
    height: "37px !important",
    "&>h6": {
      background: "rgba(255, 255, 255, 0.1)",
      border: "0.5px solid #FFFFFF",
      height: "20px",
      width: "35px",
      borderRadius: "2px",
      paddingRight: "-5px",
      color: `${theme.palette.white.main} !important`,
    },
  },
  printButton: {
    height: "37px !important",
    width: "37px !important",
    marginTop: "12px !important",
    // marginLeft: "5px !important",
    "&>svg": {
      height: "20px !important",
      width: "20px !important",
    },
    // [theme.breakpoints.down("1200")]: {
    //   display: "none !important",
    // },
  },
  rsArchiveIconWeb: {
    height: "37px !important",
    width: "37px !important",
    marginTop: "12px !important",
    // marginLeft: "15px !important",
    "&>svg": {
      height: "20px !important",
      width: "20px !important",
      fill: "white !important",
    },
    // [theme.breakpoints.down("1200")]: {
    //   display: "none !important",
    // },
  },
  rsArchiveIconWebOutline: {
    height: "37px !important",
    width: "37px !important",
    marginTop: "12px !important",
    // marginLeft: "15px !important",
    "&>svg": {
      height: "20px !important",
      width: "20px !important",
      fill: "#7BC044",
    },
    // [theme.breakpoints.down("1200")]: {
    //   display: "none !important",
    // },
  },

  rsSkeleton: {
    width: "150px",
    marginRight: "10px",
    // marginTop: "-20px",
    background: "rgba(266,266,266,0.27) !important",
  },
  rsCollectionSkeleton: {
    width: "150px",
    marginRight: "10px",
    // marginTop: "-10px",
    background: "rgba(266,266,266,0.27) !important",
  },

  rsGrid: {
    // [theme.breakpoints.down("768")]: {
    //   padding: "21px",
    // },
    [theme.breakpoints.down("1200")]: {
      // padding: "21px",
    },
    [theme.breakpoints.down("786")]: {
      padding: "0px",
    },
  },
  dayAutocomplete: {
    background: theme.palette.white.main,
    boxShadow: "0px 0px 10px rgb(90 104 114 / 10%)",
    borderRadius: "4px",
    lineHeight: "30px",
    minWidth: "230px !important",
    maxWidth: "250px !important",
    whiteSpace: "onwrap",
    height: "39px",
    marginRight: "13px",
    marginLeft: "9px",
    "&>div": {
      marginTop: "3px",
      padding: "10px",
      color: theme.palette.secondary.main,
      fontSize: "14px",
      height: "23px !important",
      marginTop: "0px !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "& .MuiMenuItem": {
      color: theme.palette.secondary.main,
    },
    [theme.breakpoints.down("1176")]: {
      display: "none !important",
    },
  },

  rsFilterIconUnCollectedOther: {
    [theme.breakpoints.between("1300", "1537")]: {
      width: "48px !important",
    },
    "&>button": {
      padding: "0px 0px !important",
      fontSize: "14px !important",
      height: "37px !important",
      marginTop: "0px !important",
      marginRight: "9px !important",
      minWidth: "42px !important",
      "&>svg": {
        fill: `${theme.palette.primary.main} !important`,
      },
    },
    // [theme.breakpoints.up("1200")]: {
    //   display: "none !important",
    // },
  },

  rsSurgeryAutoCompleteWebOther: {
    height: "37px",
    marginTop: "0px !important",
    width: "150px !important",
    [theme.breakpoints.down("1650")]: {
      width: "150px !important",
    },
    "&>div": {
      // border: "1px solid black !important",
      marginTop: "0px !important",
      "&>div": {
        border: "1px solid black !important",
        overflow: "hidden",
        "&:focus": {
          borderColor: "#7BC044 !important",
        },
        "&:focus-within": {
          borderColor: "#7BC044 !important",
        },
      },
    },
  },
  rsSurgeryAutoComplete: {
    height: "37px",
    marginTop: "0px !important",
    width: "150px !important",
    [theme.breakpoints.down("1650")]: {
      width: "150px !important",
    },
    "&>div": {
      // border: "1px solid black !important",
      marginTop: "0px !important",
      "&>div": {
        border: "1px solid black !important",
        "&:focus": {
          borderColor: "#7BC044 !important",
        },
        "&:focus-within": {
          borderColor: "#7BC044 !important",
        },
      },
    },
  },
  rsprintButton: {
    height: "37px !important",
    width: "37px !important",
    marginRight: "10px",
    "&>button": {
      padding: "0px !important",
      minWidth: "42px !important",
      marginTop: "0 !important",
      "&>svg": {
        fill: "white",
      },
    },
    "&:nth-of-type(2)": {
      [theme.breakpoints.down("1301")]: {
        marginRight: "14px",
      },
    },
    "&:nth-of-type(3)": {
      [theme.breakpoints.down("1301")]: {
        marginRight: "4px",
      },
    },
  },
  rsarchiveButton: {
    height: "37px !important",
    width: "37px !important",
    marginRight: "10px",
    marginLeft: "10px !important",
    "&>button": {
      padding: "0px !important",
      minWidth: "42px !important",
      marginTop: "0 !important",
      "&>svg": {
        fill: "rgb(123, 192, 68)",
      },
    },
  },
  tooltip: {
    left: "10px !important",
    top: "13px !important",
  },
  diactiveChaseup: {
    "&>span": {
      "&>svg": {
        // background: "rgb(123, 192, 68)",
        color: "#5A6872",
      },
      color: "black",
      whiteSpace: "nowrap",
    },
  },
  rsChaseUpIcon: {
    "&>span": {
      whiteSpace: "nowrap",
      color: "#5A6872",
      "&>svg": {
        background: "rgb(123, 192, 68)",
        color: "white",
      },
    },
  },
  rsListAlignment: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "40px",
    "&>div": {
      display: "flex",
    },
  },
  rsBackSurgery: {
    whiteSpace: "nowrap",
    display: "flex",
    justifyContent: "flex-end",
    // width: "88%",
    marginLeft: "10px",
    marginRight: "10px",
    [theme.breakpoints.down("1680")]: {
      // width: "87%",
    },
    [theme.breakpoints.down("1600")]: {
      // width: "200px",
    },
    "&>button": {
      // width: "200px !important",
      height: "38px !important",
    },
  },
  gridRow: {
    display: "flex",
    justifyContent: "space-between",
    width: "-webkit-fill-available",
    // [theme.breakpoints.down("1601")]: {
    padding: "2px",
    // },
  },
  gridNotSurgey: {
    display: "flex",
    justifyContent: "flex-start",
    width: "-webkit-fill-available",
    padding: "2px",
  },
  rsiconBtn: {
    width: "auto !important",
    marginRight: "5px",
    marginLeft: "5px !important",
    [theme.breakpoints.down("1145")]: {
      marginLeft: "0px !important",
    },
    "&>div": {
      background: "white !important",
      display: "flex !important",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "5px",
      // cursor: "pointer",
      width: "auto !important",
      height: "40px !important",
      padding: "6px",
      "&>button": {
        padding: "4px",
        cursor: "pointer",
        color: "black",
        fontWeight: "500!important",
        fontSize: "16px",
        fontFamily: "Poppins !important",
        "&:hover": {
          background: "transparent",
        },
        "&>svg": {
          fill: "black",
          "&>rect": {
            fill: "black",
          },
          // fontSize: "35px",
        },
      },
    },
    "&>hr": {
      color: "#5A6872",
      background: "#5A6872",
      paddingTop: "5px",
      paddingBottom: "5px",
    },
  },
  customMenuItem: {
    "&:focus": {
      backgroundColor: "transparent !important", // Remove the background color on focus
      outline: "none !important", // Remove the outline on focus
    },
    "&:hover": {
      backgroundColor: "transparent !important", // Remove the background color on focus
      outline: "none !important", // Remove the outline on focus
    },
  },
  rsActiveBtn: {
    display: "flex",
    background: theme.palette.primary.main,
    height: "10px",
    width: "10px",
    borderRadius: "5px",
    position: "relative",
    marginTop: "8px",
    marginLeft: "5px",
    justifyContent: "flex-start !important",
  },
  rsWaringFilterlistview: {
    "&>li": {
      display: "block",
      marginBottom: "15px",
      // marginTop: "10px",
      "&>svg": {
        top: "5px",
        position: "relative",
      },
    },
  },
  rsCursor: {
    cursor: "pointer",
  },
  rsButtonHowtoIcon: {
    // background: "#7bc044 !important",
    padding: "10px !important",
    borderRadius: "5px !important",
    marginLeft: "4px",
    "&>span": {
      marginLeft: "-8px",
    },
    "&>svg": {
      "&>path": {
        fill: "#7bc044 !important",
        stroke: "white !important",
      },
    },
  },
  rsButtonFromSurgery: {
    background: "#7bc044 !important",
    padding: "10px !important",
    borderRadius: "5px !important",
    marginLeft: "4px",
    height: "35px !important",

    "&>svg": {
      fill: "white !important",
      "&>path": {
        fill: "white !important",
        // stroke: "white !important",
      },
    },
  },
  rsCollapseContainer: {
    padding: "0px !important",
    [theme.breakpoints.down("409")]: {
      height: "49px",
    },
  },
  rsCollapse: {
    padding: "5px 11px 3px 13px",
  },
  rsCollapseSurgery: {
    padding: "5px 11px 5px 11px",
  },
  collapseAdd: {
    display: "flex",
    [theme.breakpoints.down("1145")]: {
      width: "100%",
    },
  },
  filterConatiner: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
  },
  mobileHeader: {
    [theme.breakpoints.down("409")]: {
      marginRight: "0px !important",
    },
    "&>div:nth-child(1)": {
      [theme.breakpoints.down("409")]: {
        justifyContent: "space-between !important",
        // marginTop:"5px"
      },
    },
    "&>div:nth-child(2)": {
      [theme.breakpoints.down("409")]: {
        justifyContent: "space-between !important",
        marginTop: "8px",
        "&>div:nth-child(2)": {
          marginRight: "0px !important",
        },
      },
    },
  },
}));

/** Uncollected title */
const unCollectedTableCells = {
  name: {
    id: "name",
    label: "PATIENT",
    sortable: true,
    icons: true,
    show: true,
    showValue: false,
  },
  dob: {
    id: "dob",
    label: "DOB",
    sortable: true,
    show: true,
    icons: false,
    showValue: true,
  },
  surgery_name: {
    id: "surgery_name",
    label: "SURGERY",
    sortable: true,
    show: true,
    icons: false,
    showValue: true,
  },
  created_user_type: {
    id: "created_user_type",
    label: "ORDERED BY",
    sortable: true,
    show: true,
    icons: false,
    showValue: true,
  },
  uncollected_count: {
    id: "uncollected_count",
    label: "ITEMS",
    sortable: true,
    show: true,
    icons: false,
    showValue: true,
    tooltip: "Number of uncollected medication items",
  },
  outstanding_days: {
    id: "outstanding_days",
    label: "DAYS OUTSTANDING",
    sortable: false,
    show: true,
    icons: false,
    showValue: true,
    tooltip:
      "Number of days since the prescription order was placed. (If the record is created from the Rx, the outstanding days are not displayed.)",
  },
  created_at: {
    id: "created_at",
    label: "ORDERED",
    sortable: true,
    show: true,
    icons: false,
    showValue: true,
  },
  pharmacy_name: {
    id: "pharmacy_name",
    label: "PHARMACY",
    sortable: true,
    show: false,
    icons: false,
    showValue: true,
  },
  action: {
    id: "action",
    label: "ACTIONS",
    sortable: false,
    show: true,
    icons: false,
    showValue: false,
  },
};

/** Uncollected title */
const tableCellsPharmacy = {
  name: {
    id: "name",
    label: "PATIENT",
    sortable: true,
    show: true,
    showValue: false,
    icons: true,
  },
  dob: {
    id: "dob",
    label: "DOB",
    sortable: true,
    show: true,
    showValue: true,
    icons: false,
  },
  surgery_name: {
    id: "surgery_name",
    label: "SURGERY",
    sortable: true,
    show: true,
    showValue: true,
    icons: false,
  },
  created_user_type: {
    id: "created_user_type",
    label: "ORDERED BY",
    sortable: true,
    show: true,
    showValue: true,
    icons: false,
  },
  uncollected_count: {
    id: "uncollected_count",
    label: "ITEMS",
    sortable: true,
    show: true,
    showValue: true,
    icons: false,
    tooltip: "Number of uncollected medication items",
  },
  outstanding_days: {
    id: "outstanding_days",
    label: "DAYS OUTSTANDING",
    sortable: false,
    show: true,
    icons: false,
    showValue: true,
    tooltip:
      "Number of days since the prescription order was placed. (If the record is created from the Rx, the outstanding days are not displayed.)",
  },
  created_at: {
    id: "created_at",
    label: "ORDERED",
    sortable: true,
    show: true,
    showValue: true,
    icons: false,
  },
  action: {
    id: "action",
    label: "ACTIONS",
    sortable: false,
    show: true,
    showValue: false,
    icons: false,
  },
};

/** Collected title */
const collectedTableCells = {
  name: {
    id: "name",
    label: "NAME",
    sortable: true,
    show: true,
    showValue: false,
  },
  dob: {
    id: "dob",
    label: "DOB",
    sortable: true,
    show: true,
    showValue: true,
  },
  surgery_name: {
    id: "surgery_name",
    label: "SURGERY",
    sortable: true,
    show: true,
    showValue: true,
  },
  pharmacy_name: {
    id: "pharmacy_name",
    label: "PHARMACY",
    sortable: true,
    show: true,
    showValue: true,
  },
  order_by: {
    id: "order_by",
    label: "ORDER BY",
    sortable: true,
    show: true,
    showValue: true,
  },
  collected_at: {
    id: "collected_at",
    label: "ARRIVED AT",
    sortable: true,
    show: true,
    showValue: true,
  },
  action: {
    id: "action",
    label: "ACTIONS",
    sortable: false,
    show: true,
    showValue: false,
  },
};
/** Collected title */
const collectedTableCellsPharmacy = {
  name: {
    id: "name",
    label: "NAME",
    sortable: true,
    show: true,
    showValue: false,
  },
  dob: {
    id: "dob",
    label: "DOB",
    sortable: true,
    show: true,
    showValue: true,
  },
  surgery_name: {
    id: "surgery_name",
    label: "SURGERY",
    sortable: true,
    show: true,
    showValue: true,
  },
  order_by: {
    id: "order_by",
    label: "ORDER BY",
    sortable: true,
    show: true,
    showValue: true,
  },
  collected_at: {
    id: "collected_at",
    label: "ARRIVED AT",
    sortable: true,
    show: true,
    showValue: true,
  },
  action: {
    id: "action",
    label: "ACTIONS",
    sortable: false,
    show: true,
    showValue: false,
  },
};

const CollectionMain = (props) => {
  const {
    getCollectionRxAction,
    collectionRxList,
    resetCollectionRxState,
    deleteCollectionRxAction,
    deleteCollectionRx,
    getCollectionCountAction,
    collectionListCount,
    collectionViewRxAction,
    collectionViewRxDetails,
    addAndUpdateNoteAction,
    addAndUpdateNote,
    deleteNoteAction,
    deleteSingleNote,
    globalSetting,
    updateGlobalSettingAction,
    createChaseUpDetails,
    UpdateChaseUp,
    getPrintCollectionListAction,
    printCollectionList,
    checkedChaseUp,
    setCheckedChaseUp,
    getPatientListAction,
    getHomeListAction,
    getSinglePatientAction,
    singlePatientData,
    getPatientHistoryAction,
    patientMedicationHistoryList,
    getArchiveCollectionAction,
    getMedicationArchiveAction,
    archiveMedi,
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const { width } = useViewport();
  const classes = useStyle();
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const isPrescriptionTracking = process.env.REACT_APP_USE_PRESCRIPTION_TRACKING === "true" ? true : false;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [deleteCollectionDetails, setDeleteCollectionDetails] = useState(false);
  const [collectionActionType, setCollectionActionType] = useState("");
  const [collectionDeleteId, setCollectionDeleteId] = useState("");
  // const collectionRecordLimit = isPrescriptionTracking ? 10 : 20;
  const collectionRecordLimit = 20;
  const { headerSelectedPharmaciesFilter, loginUserDetail } = useSelector(
    (state) => state.user
  );
  const [isOpenViewRx, setIsOpenViewRx] = useState(false);
  const [
    collectAndUncollectedViewRxDetails,
    setCollectAndUncollectedViewRxDetails,
  ] = useState("");
  const [openCollectedNoteList, setOpenCollectedNoteList] = useState(false);
  const [showCollectedNoteList, setShowCollectedNoteList] = useState({});
  const [openNotePopup, setOpenNotePopup] = useState(false);
  const [selectedNoteDetails, setSelectedNoteDetails] = useState("");
  const [noteId, setNoteId] = useState("");
  const [deleteNoteData, setDeleteNoteData] = useState(false);
  const [globalSettingDialogStatus, serGlobalSettingDialogStatus] =
    useState(false);
  const [collectedUncollectedListShow, setCollectedUncollectedListShow] =
    React.useState("un_collected");
  const defaultColumnOrderBy = "asc";
  const [columnSortingOrder, setColumnSortingOrder] = useState({
    orderBy: "",
    sortBy: "ASC",
  });
  const [showPrintData, setShowPrintData] = useState(false);
  const maxValue = 1;
  const surgeryListFlag = true;
  const [changeSurgeryDropDownValue, setChangeSurgeryDropDownValue] = useState(
    []
  );
  const [columnsPopperAnchorEl, setColumnsPopperAnchorEl] = useState(null);
  // const { selectedHeaderPharmacyId } = useHeaderPharmacySelection();
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  const isFirstRender = useRef(true);
  const [chaseUpHrs, seTChaseUpHrs] = useState();
  const [openFilterPopup, setOpenFilterPopup] = useState(false);
  const showDataBasedOnRole = loginUserDetail?.data?.data?.role;
  const [detailsDialog, setDetailsDialog] = useState(false);
  const [patientDetails, setPatientDetails] = useState({});
  const query = new URLSearchParams(window.location.search);
  const [changeGroupDropDownValue, setChangeGroupDropDownValue] = useState([]);
  const [openTableColumn, setOpenTableColumn] = useState(false);
  const [openTableColumnCollected, setOpenTableColumnCollected] =
    useState(false);
  const [collationActionType, setCollationActionType] = useState("");
  const [tableColumns, setTableColumns] = useState({});
  const [collectedTableColumns, setCollectedTableColumns] = useState({});
  const activeColumns =
    getLocalStorage("dynamicColumnUnCollected")?.split(",") || [];
  const columnSequenceUnCollected =
    getLocalStorage("dynamicColumnSequenceUnCollected")?.split(",") || [];
  const columnSequenceCollected =
    getLocalStorage("dynamicColumnSequenceCollected")?.split(",") || [];
  const activeCollectedColumns =
    getLocalStorage("dynamicColumnCollected")?.split(",") || [];
  const [archive, setArchive] = useState(false);
  const groupListFlag = true;
  const [isOpenEditDobModel, setIsOpenEditDobModel] = useState(false);
  const [editDobDate, setEditDobDate] = useState({});
  const [orderDayfilter, setOrderDayfilter] = useState("All orders");
  const [orderDayValue, setOrderDayValue] = useState("");
  const orderDayMenuItems = [
    { index: 0, lable: "All orders", value: "0" },
    { index: 1, lable: "Orders made after 24 hours", value: "24" },
    { index: 2, lable: "Orders made after 48 hours", value: "48" },
    { index: 3, lable: "Orders made after 72 hours", value: "72" },
  ];
  const [surgeryClick, setSurgeryClick] = useState(false);
  const [openViewOrder, setOpenViewOrder] = useState(false);
  const [openFaxOrder, setOpenFaxOrder] = useState(false);
  const [phone, setPhone] = useState(false);
  const [fax, setFax] = useState(false);
  const [viewOrderData, setViewOrderData] = useState({});
  const [viewOrderDataMail, setViewOrderDataMail] = useState({});
  const [patientDetailOpen, setPatientDetailOpen] = useState(false);
  const [patientId, setPatientId] = useState("");
  const [isArchive, setIsArchive] = useState(false);
  const [urgentFilter, setUrgentFilter] = useState(false);
  const [readyToCollect, setReadyToCollect] = useState(false);
  const [checked, setChecked] = React.useState(false);
  const [subscriptionDialog, setSubscritionDialog] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [surgeryOpen, setSurgeryOpen] = useState(false);
  const [groupOpen, setGroupOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [firstChangeSurgery, setFirstChangeSurgery] = useState(true);
  const [firstChangeGroup, setFirstChangeGroup] = useState(true);
  const open = Boolean(anchorEl);
  const handleClickFilter = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleCloseFilter = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (getLocalStorage("surgeryList")) {
      setChangeSurgeryDropDownValue(JSON.parse(getLocalStorage("surgeryList")));
    }
  }, [getLocalStorage]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    getList({
      offset: (newPage - 1) * 10,
      limit: 10,
      is_page_change: true,
    });
  };

  /** Get api call main function */
  const getList = (params = {}) => {
    if (params.offset === undefined || params.offset === 0) {
      setCurrentPage(1);
    }
    let tempSurgeryList = getLocalStorage("surgeryList")
      ? Object.keys(JSON.parse(getLocalStorage("surgeryList")))
      : [];
    let tempGroupList = getLocalStorage("groupList")
      ? Object.keys(JSON.parse(getLocalStorage("groupList")))
      : [];

    let payload = {
      offset: 0,
      limit: collectionRecordLimit,
      q: searchValue,
      type: collectedUncollectedListShow,
      surgery_ids:
        tempSurgeryList.length > 0
          ? tempSurgeryList
          : Object.keys(changeSurgeryDropDownValue),
      group_id:
        tempGroupList.length > 0
          ? tempGroupList
          : Object.keys(changeGroupDropDownValue),
      order_by: params.orderBy || columnSortingOrder.orderBy,
      sort_by: (params.sortBy || columnSortingOrder.sortBy).toUpperCase(),
      is_archive: archive ? true : false,
    };

    if (showDataBasedOnRole === "user") {
      payload.after_order_date_hour = orderDayValue;
    }
    if (collectedUncollectedListShow === "un_collected") {
      payload.is_chase_up =
        getLocalStorage("chaseUp") === "true" ? true : checkedChaseUp;
    }
    if (collectedUncollectedListShow === "un_collected") {
      payload.is_urgent = urgentFilter;
    }

    if (collectedUncollectedListShow === "un_collected") {
      payload.ready_to_collect = readyToCollect;
    }
    if (selectedHeaderPharmacyId && selectedHeaderPharmacyId !== "all") {
      payload.pharmacy_id = [selectedHeaderPharmacyId];
    }

    payload = {
      ...payload,
      ...params,
    };

    let role = loginUserDetail?.data?.data?.role;

    if (role !== "user") {
      delete payload.after_order_date_hour;
    }

    getCollectionRxAction(getClearObject(payload));
  };

  // Fetch fresh data on route change
  useEffect(() => {
    if (location.state?.isSurgeryListModule != true) {
      getList({ offset: 0, limit: 20 });
    }
    getCollectionCountAction({});
    setLocalStorage("urlcollection", "none");
  }, []);

  useEffect(() => {
    let payload;
    let driverHourData;

    let role = loginUserDetail?.data?.data?.role;

    if (role === "user") {
      if (globalSetting?.data?.DriverHoursSetting === undefined) {
        return;
      }

      driverHourData = globalSetting?.data?.DriverHoursSetting?.gs_value;

      let textFromOrderDayMenuItems = orderDayMenuItems.find(
        (item) => item?.value === driverHourData?.toString()
      )?.lable;

      setOrderDayfilter(textFromOrderDayMenuItems);

      setOrderDayValue(driverHourData);
      payload = {
        offset: 0,
        is_chase_up:
          getLocalStorage("chaseUp") === "true" ? true : checkedChaseUp,
        type: "un_collected",
        // limit: isPrescriptionTracking ? 10 : 20,
        limit: 20,
        after_order_date_hour: driverHourData,
      };
    } else {
      payload = {
        offset: 0,
        is_chase_up:
          getLocalStorage("chaseUp") === "true" ? true : checkedChaseUp,
        type: "un_collected",
        // limit: isPrescriptionTracking ? 10 : 20,
        limit: 20,
      };
    }

    let payloadlist = {
      offset: 0,
      is_chase_up: false,
      type: "un_collected",
      // limit: isPrescriptionTracking ? 10 : 20,
      limit: 20,
    };
    let payLoad = {};
    if (
      getLocalStorage("urlcollection") === "collection" &&
      selectedHeaderPharmacyId === "all" &&
      query.get("from") !== "surgeries" &&
      query.get("action") !== "click"
    ) {
      if (getLocalStorage("chaseUp") === "true") {
        setCheckedChaseUp(true);
      }

      getCollectionRxAction(payload);
      getCollectionCountAction(payLoad);
      setLocalStorage("urlcollection", "none");
      setSurgeryClick(false);
    } else {
      // if (
      //   query.get("from") !== "surgeries" &&
      //   query.get("action") !== "click"
      // ) {
      //   getCollectionRxAction(payload);
      //   getCollectionCountAction(payLoad);
      // }
    }
    return () => {
      if (window.location.pathname !== "/rx-collection" && window.location.pathname !== "/prescription-tracking") {
        resetCollectionRxState("collectionRxList", {
          loading: false,
          data: {},
          error: "",
          success: false,
        });
        if (
          query.get("from") === "surgeries" &&
          query.get("action") === "click"
        ) {
          getCollectionRxAction(payloadlist);
          getCollectionCountAction(payLoad);
        }
        // setCheckedChaseUp(false);
        // setLocalStorage("chaseUp", false);
        // getCollectionRxAction(payloadlist);
        // getCollectionCountAction(payLoad);
        // window.onbeforeunload = null;
        // setLocalStorage("pharmacyChange", false);
      }
    };
  }, [globalSetting, loginUserDetail]);
  const handleClickFilterClear = () => {
    setChangeSurgeryDropDownValue([]);
    setLocalStorage("surgeryList", {});
    setChangeGroupDropDownValue([]);
    setLocalStorage("groupList", {});
    setCheckedChaseUp(false);
    setLocalStorage("chaseUp", false);
    setUrgentFilter(false);
    setFilterCount(0);
    let payload = {
      offset: 0,
      is_chase_up: false,
      type: collectedUncollectedListShow,
      // limit: isPrescriptionTracking ? 10 : 20,
      limit: 20,
    };
    if (selectedHeaderPharmacyId !== "" && selectedHeaderPharmacyId !== "all") {
      payload.pharmacy_id = [selectedHeaderPharmacyId];
    }

    if (showDataBasedOnRole === "user") {
      payload.after_order_date_hour = orderDayValue;
    }
    if (searchValue !== "") {
      payload.q = searchValue;
    }
    getCollectionRxAction(payload);
  };
  useEffect(() => {
    if (query.get("from") === "surgeries" && query.get("action") === "click") {
      setSurgeryClick(true);
      if (query.get("data")) {
        try {
          const data = JSON.parse(query.get("data"));
          if (
            typeof data === "object" &&
            !Array.isArray(data) &&
            data !== null
          ) {
            const surgeryInfo = {
              [data.id]: {
                id: data.id,
                name: data.name,
                email: data.email,
              },
            };
            //Update your data in state
            setChangeSurgeryDropDownValue(surgeryInfo);
            handleSurgeryChange(surgeryInfo);
            //Remove all querystring from url in react
            navigate.replace({
              search: query.toString(),
            });
          } else {
            //Redirect to back
            navigate(location.pathname);
          }
        } catch (error) {
          //Redirect to back
          navigate(location.pathname);
        }
      }
    }
  }, [location.search]);

  /** Header filter useEffect */
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    let payLoad = {};
    if (!collectionRxList?.loading) {
      if (checked === true) {
        getCollectionCountAction(payLoad);


        getList(payLoad);
      } else {
        if (
          selectedHeaderPharmacyId !== "" &&
          selectedHeaderPharmacyId !== "all" &&
          query.get("from") !== "surgeries" &&
          query.get("action") !== "click" &&
          !(columnSortingOrder.orderBy && columnSortingOrder.sortBy)
        ) {
          payLoad = {
            pharmacy_id: [selectedHeaderPharmacyId],
          };
          getCollectionCountAction(payLoad);

          getList(payLoad);
        } else if (
          getLocalStorage("pharmacyChange") === "true" &&
          !(columnSortingOrder.orderBy && columnSortingOrder.sortBy)
        ) {
          getList(payLoad);
        }
        if (columnSortingOrder.orderBy && columnSortingOrder.sortBy) {
          getList();
        }
        // if (urgentFilter) {
        //   getList(payLoad);
        // } else {
        //   getList(payLoad);
        // }
      }
      //surgery page to collection is not there based on add condition
      // if (!query.get("from")) {
      // getList(payLoad);
      // }
    }
  }, [
    selectedHeaderPharmacyId,
    collectedUncollectedListShow,
    columnSortingOrder.orderBy,
    columnSortingOrder.sortBy,
    urgentFilter,
    readyToCollect,
  ]);

  /** Count UseEffect */
  // useEffect(() => {
  //   let payLoad = {};
  //   if (!collectionListCount?.loading) {
  //     if (selectedHeaderPharmacyId !== "") {
  //       payLoad = {
  //         pharmacy_id: [selectedHeaderPharmacyId],
  //       };
  //       getCollectionCountAction(payLoad);
  //     } else if (getLocalStorage("pharmacyChange") == "true") {
  //       getCollectionCountAction(payLoad);
  //     }
  //   }
  // }, [selectedHeaderPharmacyId]);

  /** Collected & UnCollected List Count api useEffect */
  useEffect(() => {
    let baseColumns =
      ["pharmacist_staff", "pharmacy"].indexOf(showDataBasedOnRole) !== -1
        ? tableCellsPharmacy
        : unCollectedTableCells;
    let allColumns = {};
    Object.keys(baseColumns).forEach((key) => {
      allColumns[key] = { ...baseColumns[key] };
    });

    let baseCollectedColumns =
      ["pharmacist_staff", "pharmacy"].indexOf(showDataBasedOnRole) !== -1
        ? collectedTableCellsPharmacy
        : collectedTableCells;
    let allCollectedColumns = {};
    Object.keys(baseCollectedColumns).forEach((key) => {
      allCollectedColumns[key] = { ...baseCollectedColumns[key] };
    });

    if (!isPrescriptionTracking) {
      delete allColumns.outstanding_days;
    }

    if (activeColumns.length > 0) {
      Object.keys(allColumns)?.map((key) => {
        if (allColumns[key].showValue) {
          if (activeColumns.indexOf(allColumns[key].id) !== -1) {
            allColumns[key].show = true;
          } else {
            allColumns[key].show = false;
          }
        }
      });
    }
    if (activeCollectedColumns.length > 0) {
      Object.keys(allCollectedColumns)?.map((key) => {
        if (allCollectedColumns[key].showValue) {
          if (
            activeCollectedColumns.indexOf(allCollectedColumns[key].id) !== -1
          ) {
            allCollectedColumns[key].show = true;
          } else {
            allCollectedColumns[key].show = false;
          }
        }
      });
    }
    allColumns = getNewOrder(columnSequenceUnCollected, allColumns);
    allCollectedColumns = getNewOrder(
      columnSequenceCollected,
      allCollectedColumns
    );
    setCollectedTableColumns(allCollectedColumns);
    setTableColumns(allColumns);
  }, [location.pathname, isPrescriptionTracking, showDataBasedOnRole]);

  /** Listing data show based on scroll useEffect*/
  useEffect(() => {
    if (entry.isIntersecting) {
      if (
        collectionRxList?.data?.list?.length !==
        collectionRxList?.data?.filterd_record
      ) {
        if (collectedUncollectedListShow === "un_collected") {
          getList({
            offset: collectionRxList?.data?.list?.length,
            limit: collectionRecordLimit,
            type: collectedUncollectedListShow,
            order_by: columnSortingOrder.orderBy,
            sort_by: columnSortingOrder.sortBy.toUpperCase(),
            surgery_ids: Object.keys(changeSurgeryDropDownValue),
            is_archive: archive ? true : false,
          });
        } else {
          getList({
            offset: collectionRxList?.data?.list?.length,
            limit: collectionRecordLimit,
            type: collectedUncollectedListShow,
            order_by: columnSortingOrder.orderBy,
            sort_by: columnSortingOrder.sortBy.toUpperCase(),
            surgery_ids: Object.keys(changeSurgeryDropDownValue),
          });
        }
      }
    }
  }, [entry]);

  /** Search debounce Function*/
  const searchUserDebounce = useRef(
    _.debounce((searchString, otherStateValues = {}) => {
      getList({
        ...(searchString && {
          q: searchString,
        }),
        ...otherStateValues,
      });
    }, 500)
  );

  /** Handle search event */
  const handleSearch = (newValue) => {
    if (collectedUncollectedListShow === "un_collected") {
      searchUserDebounce.current(newValue, {
        surgery_ids: Object.keys(changeSurgeryDropDownValue),
        group_id: Object.keys(changeGroupDropDownValue),
        pharmacy_id:
          selectedHeaderPharmacyId !== "all" ? [selectedHeaderPharmacyId] : [],
        order_by: columnSortingOrder.orderBy,
        sort_by: columnSortingOrder.sortBy.toUpperCase(),
        type: collectedUncollectedListShow,
        is_chase_up:
          getLocalStorage("chaseUp") === "true" ? true : checkedChaseUp,
        is_archive: archive ? true : false,
        is_urgent: urgentFilter,
        ready_to_collect: readyToCollect,
        after_order_date_hour: orderDayValue,
      });
    } else {
      searchUserDebounce.current(newValue, {
        surgery_ids: Object.keys(changeSurgeryDropDownValue),
        group_id: Object.keys(changeGroupDropDownValue),
        pharmacy_id:
          selectedHeaderPharmacyId !== "all" ? [selectedHeaderPharmacyId] : [],
        order_by: columnSortingOrder.orderBy,
        sort_by: columnSortingOrder.sortBy.toUpperCase(),
        type: collectedUncollectedListShow,
        is_chase_up:
          getLocalStorage("chaseUp") === "true" ? true : checkedChaseUp,
        after_order_date_hour: orderDayValue,
      });
    }
  };

  /** delete collection event*/
  const handleDeleteRepeatOrder = () => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    let payLoad = {
      offset: 0,
    };
    deleteCollectionRxAction(collectionDeleteId);
    getPatientListAction(payLoad);
    // }
    // getHomeListAction(payload);
  };
  const handleArchiveRepeatOrder = () => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    let payLoad = {
      id: collectionDeleteId,
      is_archive: archive ? false : true,
    };
    // deleteCollectionRxAction(collectionDeleteId);
    getArchiveCollectionAction(payLoad);
    // }
  };

  /** delete Note event*/
  const handleDeleteNote = () => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    const payload = {
      type: collectedUncollectedListShow,
    };
    deleteNoteAction(noteId, payload);
    // }
  };

  /** Delete loading useEffect*/
  useEffect(() => {
    if (
      !deleteCollectionRx?.loading &&
      Object.keys(deleteCollectionRx?.data)?.length
    ) {
      setDeleteCollectionDetails(false);
      setCollectionDeleteId("");
      resetCollectionRxState("deleteCollectionRx", "");
      // getHomeListAction();
      let payLoad = {};
      if (
        selectedHeaderPharmacyId !== "" &&
        selectedHeaderPharmacyId !== "all"
      ) {
        payLoad = {
          pharmacy_id: [selectedHeaderPharmacyId],
        };
      }

      if (
        selectedHeaderPharmacyId !== "" &&
        selectedHeaderPharmacyId !== "all"
      ) {
        let payloadHome = { pharmacy_id: [selectedHeaderPharmacyId] };
        getCollectionCountAction(payLoad);
        getHomeListAction(payloadHome);
      } else {
        let payLoad = {};
        if (
          selectedHeaderPharmacyId !== "" &&
          selectedHeaderPharmacyId !== "all"
        ) {
          payLoad = {
            pharmacy_id: [selectedHeaderPharmacyId],
          };
        }
        getCollectionCountAction(payLoad);
        getHomeListAction();
      }
    }
  }, [deleteCollectionRx]);

  /** handle chaseUp selection */
  const handleSelectChaseUp = (e) => {
    if (checkedChaseUp) {
      setFilterCount((prevCount) => prevCount - 1);
    }

    let isChecked = !checkedChaseUp;
    setCheckedChaseUp(isChecked);
    setLocalStorage("chaseUp", isChecked);
    getList({
      is_chase_up: isChecked,
    });
  };

  useEffect(() => {
    if (checkedChaseUp) {
      setFilterCount((prevCount) => prevCount + 1);
    }
  }, [checkedChaseUp]);
  /**handle Surgery Change */
  const handleSurgeryChange = (value) => {
    if (Object.keys(value).length == 0) {
      if (filterCount === 0 || filterCount < 0) {
        setFilterCount(0);
      } else {
        setFilterCount((prevCount) => prevCount - 1);
      }
      setFirstChangeSurgery(true);
    }
    if (firstChangeSurgery) {
      if (Object.keys(value).length == 1) {
        setFilterCount((prevCount) => prevCount + 1);
      }
      setFirstChangeSurgery(false);
    } else if (
      firstChangeSurgery === false &&
      (Object.keys(value).length == 1 || Object.keys(value).length > 1)
    ) {
      setFilterCount(1);
    }

    setChangeSurgeryDropDownValue(value);

    setLocalStorage("surgeryList", value);
    if (!query.get("from")) {
      getList({
        surgery_ids: Object.keys(value),
      });
    } else {
      getList({
        surgery_ids: Object.keys(value),
      });
    }
  };

  /** handle Group Change */
  const handleGroupChange = (value) => {
    if (Object.keys(value).length == 0) {
      setFilterCount((prevCount) => prevCount - 1);
      setFirstChangeGroup(true);
    }
    if (firstChangeGroup) {
      if (Object.keys(value).length == 1) {
        setFilterCount((prevCount) => prevCount + 1);
      }
      setFirstChangeGroup(false);
    }
    setChangeGroupDropDownValue(value);
    setLocalStorage("groupList", value);
    getList({
      group_id: Object.keys(value),
    });
  };

  /** get print collection list */
  const handleGetCollectionPrintData = (data) => {
    let tempSurgeryList = getLocalStorage("surgeryList")
      ? Object.keys(JSON.parse(getLocalStorage("surgeryList")))
      : [];
    let payload = {
      is_archive: archive,
      is_urgent: urgentFilter,
      offset: 0,
      limit: collectionRecordLimit,
      q: searchValue,
      type: collectedUncollectedListShow,
      all_record: true,
      order_by: columnSortingOrder.orderBy,
      sort_by: columnSortingOrder.sortBy.toUpperCase(),
      is_chase_up:
        getLocalStorage("chaseUp") === "true" ? true : checkedChaseUp,
      surgery_ids:
        tempSurgeryList.length > 0
          ? tempSurgeryList
          : Object.keys(changeSurgeryDropDownValue),
      group_id: Object.keys(changeGroupDropDownValue),
    };

    if (selectedHeaderPharmacyId !== "all") {
      payload.pharmacy_id = [selectedHeaderPharmacyId];
    }
    setShowPrintData(true);
    getPrintCollectionListAction(getClearObject(payload));
  };

  /** print collection list */
  const printCollectionAction = () => {
    let printContents = document.getElementById(
      "print-collection-data"
    ).innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    document.getElementById("print-collection-data").remove();
  };
  const handleArchiveFilter = () => {
    let temp = !archive;
    setArchive(temp);
    getList({
      is_archive: temp,
    });
  };

  useEffect(() => {
    if (archive) {
      navigate(`${location.pathname}?actionType=mark-as-archived`);
    } else if (query.get("actionType") === "mark-as-archived") {
      navigate(location.pathname);
    }
  }, [archive]);

  window.addEventListener("afterprint", (event) => {
    if (showPrintData === true) {
      setShowPrintData(false);
      resetCollectionRxState("printCollectionList", {
        loading: false,
        data: [],
      });
      window.location.reload();
    }
  });
  /**handle print data */
  useEffect(() => {
    if (printCollectionList?.data?.length > 0) {
      printCollectionAction();
    }
  }, [printCollectionList?.data]);

  const handleSelectOrderDay = (e) => {
    setOrderDayfilter(e.target.value);
  };

  const handleMediArchive = (id) => {
    let historyPayload = { offset: 0, limit: isPrescriptionTracking ? 10 : 20 };
    getMedicationArchiveAction(id);
    setIsArchive(true);
  };
  useEffect(() => {
    if (archiveMedi?.data?.success && isArchive) {
      getPatientHistoryAction(patientId, {
        offset: 0,
        // limit: isPrescriptionTracking ? 10 : 20,
        limit: 20,
      });
      setIsArchive(false);
    }
  }, [archiveMedi?.data?.success]);

  const handleSurgeryopen = () => {
    setSurgeryOpen(!surgeryOpen);
  };
  const handleGroupopen = () => {
    setGroupOpen(!groupOpen);
  };

  return (
    <>
      <Grid>
        <Grid
          className={clsx(
            surgeryClick ? classes.rsCollapseSurgery : classes.rsCollapse,
            "collapseListView"
          )}
          container
        >
          {width > 408 && (
            <Box
              display={"flex"}
              alignItems={"center"}
              className={classes.rsCollection}
            >
              <Grid className={classes.rsCollectionTab}>
                {collectionListCount?.loading ? (
                  <Skeleton height={"58px"} className={classes.rsSkeleton} />
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    className={clsx(
                      classes.rsCollectionTabBtn,
                      collectedUncollectedListShow === "un_collected" &&
                      classes.rsActiveButton
                    )}
                    onClick={() => {
                      if (!collectionRxList?.loading && collectedUncollectedListShow !== "un_collected") {
                        let payLoad = {
                          offset: 0,
                          type: "un_collected",
                          is_chase_up:
                            getLocalStorage("chaseUp") === "true"
                              ? true
                              : checkedChaseUp,
                          is_archive: false,
                          // limit: isPrescriptionTracking ? 10 : 20,
                          limit: 20,
                        };
                        setArchive(false);
                        setCurrentPage(1);
                        getList(payLoad);
                        setCollectedUncollectedListShow("un_collected");
                      }
                    }}
                  >
                    {
                      isPrescriptionTracking ? (
                        <>
                          Outstanding&nbsp;
                          {collectionListCount?.data?.un_collected !== undefined && (
                            `(${abbreviateNumber(collectionListCount?.data?.un_collected)})`
                          )}
                        </>
                      ) : (
                        <>
                          Waiting Rxs &nbsp;
                          {collectionListCount?.data?.un_collected && (
                            <Typography regular variant="h6">
                              {abbreviateNumber(
                                collectionListCount?.data?.un_collected
                              )}
                            </Typography>
                          )}
                        </>
                      )
                    }
                  </Button>
                )}
                {collectionListCount?.loading ? (
                  <Skeleton
                    height={"58px"}
                    className={classes.rsCollectionSkeleton}
                  />
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    className={clsx(
                      classes.rsCollectionTabBtn,
                      collectedUncollectedListShow === "collected" &&
                      classes.rsActiveButton
                    )}
                    onClick={() => {
                      if (!collectionRxList?.loading && collectedUncollectedListShow !== "collected") {
                        let payLoad = {
                          offset: 0,
                          type: "collected",
                          is_archive: false,
                          // limit: isPrescriptionTracking ? 10 : 20,
                          limit: 20,
                        };
                        setArchive(false);
                        setCurrentPage(1);
                        getList(payLoad);
                        setCollectedUncollectedListShow("collected");
                      }
                    }}
                  >
                    {
                      isPrescriptionTracking ? (
                        <>
                          Received&nbsp;
                          {collectionListCount?.data?.collected !== undefined && (
                            `(${abbreviateNumber(collectionListCount?.data?.collected)})`
                          )}
                        </>
                      ) : (
                        <>
                          Arrived Rxs&nbsp;
                          {collectionListCount?.data?.collected && (
                            <Typography regular variant="h6">
                              {abbreviateNumber(collectionListCount?.data?.collected)}
                            </Typography>
                          )}
                        </>
                      )
                    }
                  </Button>
                )}
              </Grid>

              {collectedUncollectedListShow === "un_collected" && (
                <HtmlTooltipMain title="Add RX" className="hoverAlign">
                  {/* <IconButton
                  className={clsx("btn_green", classes.rsButtonHowtoIcon)}
                  variant="contained"
                  onClick={() => {
                    navigate(`${location.pathname}?actionType=createNewRx`);
                  }}
                >
                  <PrimaryIcon
                    width="20px"
                    icon={CopyCocumentIcon}
                    cursor="pointer"
                  />
                </IconButton> */}
                  <Button
                    variant="contained"
                    className={classes.rsButtonHowtoIcon}
                    startIcon={
                      <PrimaryIcon
                        icon={AddIcon}
                        color="white"
                        width="16px"
                        height="16px"
                      />
                    }
                    onClick={() => {
                      navigate(`${location.pathname}?actionType=createNewRx`);
                    }}
                  >
                    Add Rx
                  </Button>
                </HtmlTooltipMain>
              )}
              {surgeryClick && (
                <Box className={classes.rsBackSurgery}>
                  <HtmlTooltipMain
                    title="Back to Surgery"
                    className="hoverAlign"
                  >
                    <IconButton
                      className={clsx("btn_green", classes.rsButtonFromSurgery)}
                      variant="contained"
                      color="primary"
                      // startIcon={
                      //   <PrimaryIcon
                      //     icon={ArrowBackIosNewIcon}
                      //     color="white"
                      //     width="16px"
                      //     height="16px"
                      //   />
                      // }
                      onClick={() => {
                        navigate(`/surgery`);
                        setSurgeryClick(false);
                        setLocalStorage("collectionModule", true);
                      }}
                    >
                      <PrimaryIcon
                        icon={ArrowBackIosNewIcon}
                        color="white"
                        width="16px"
                        height="16px"
                      />
                    </IconButton>
                  </HtmlTooltipMain>
                </Box>
              )}

              {/* {width > 1300 && (
              <HtmlTooltipMain title="Print" className={classes.tooltip}>
                <Box className={classes.rsprintButton}>
                  <Button
                    // className="btn_green"
                    variant="outlined"
                    color="primary"
                    className={classes.printButton}
                    disabled={printCollectionList?.loading}
                    startIcon={
                      printCollectionList?.isLoading && (
                        <CircularProgress
                          size="20px"
                          className="rsCircularIcon"
                        />
                      )
                    }
                    onClick={() => {
                      handleGetCollectionPrintData();
                    }}
                  >
                    <PrimaryIcon
                      icon={PrintIcon}
                      color="white"
                      width="25px"
                      height="25px"
                    />
                  </Button>
                </Box>
              </HtmlTooltipMain>
            )}

            {width > 1300 &&
              collectedUncollectedListShow === "un_collected" && (
                <>
                  <HtmlTooltipMain title="Archive" className={classes.tooltip}>
                    <Box className={classes.rsprintButton}>
                      <Button
                        // className="btn_green"
                        variant={archive ? "contained" : "outlined"}
                        color="primary"
                        className={
                          archive
                            ? classes.rsArchiveIconWeb
                            : classes.rsArchiveIconWebOutline
                        }
                        onClick={() => {
                          handleArchiveFilter();
                        }}
                      >
                        <PrimaryIcon
                          icon={ArchiveIcon}
                          // color={archive ? "white" : "primary"}
                          color="white"
                          width="25px"
                          height="25px"
                        />
                      </Button>
                    </Box>
                  </HtmlTooltipMain>
                </>
              )} */}
            </Box>
          )}

          {width <= 408 && (
            <Box
              display={"flex"}
              alignItems={"center"}
              className={classes.rsCollection}
            >
              <Grid className={classes.rsCollectionTab}>
                {collectionListCount?.loading ? (
                  <Skeleton height={"58px"} className={classes.rsSkeleton} />
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    className={clsx(
                      classes.rsCollectionTabBtn,
                      collectedUncollectedListShow === "un_collected" &&
                      classes.rsActiveButton
                    )}
                    onClick={() => {
                      if (!collectionRxList?.loading && collectedUncollectedListShow !== "un_collected") {
                        let payLoad = {
                          offset: 0,
                          type: "un_collected",
                          is_chase_up:
                            getLocalStorage("chaseUp") === "true"
                              ? true
                              : checkedChaseUp,
                          is_archive: false,
                          // limit: isPrescriptionTracking ? 10 : 20,
                          limit: 20,
                        };
                        setArchive(false);
                        setCurrentPage(1);
                        getList(payLoad);
                        setCollectedUncollectedListShow("un_collected");
                      }
                    }}
                  >
                    {
                      isPrescriptionTracking ? (
                        <>
                          Outstanding&nbsp;
                          {collectionListCount?.data?.un_collected !== undefined && (
                            `(${abbreviateNumber(collectionListCount?.data?.un_collected)})`
                          )}
                        </>
                      ) : (
                        <>
                          Waiting Rxs &nbsp;
                          {collectionListCount?.data?.un_collected && (
                            <Typography regular variant="h6">
                              {abbreviateNumber(
                                collectionListCount?.data?.un_collected
                              )}
                            </Typography>
                          )}
                        </>
                      )
                    }
                  </Button>
                )}
                {collectionListCount?.loading ? (
                  <Skeleton
                    height={"58px"}
                    className={classes.rsCollectionSkeleton}
                  />
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    className={clsx(
                      classes.rsCollectionTabBtn,
                      collectedUncollectedListShow === "collected" &&
                      classes.rsActiveButton
                    )}
                    onClick={() => {
                      if (!collectionRxList?.loading && collectedUncollectedListShow !== "collected") {
                        let payLoad = {
                          offset: 0,
                          type: "collected",
                          is_archive: false,
                          // limit: isPrescriptionTracking ? 10 : 20,
                          limit: 20,
                        };
                        setCurrentPage(1);
                        getList(payLoad);
                        setCollectedUncollectedListShow("collected");
                      }
                    }}
                  >
                    {
                      isPrescriptionTracking ? (
                        <>
                          Received&nbsp;
                          {collectionListCount?.data?.collected !== undefined && (
                            `(${abbreviateNumber(collectionListCount?.data?.collected)})`
                          )}
                        </>
                      ) : (
                        <>
                          Arrived Rxs&nbsp;
                          {collectionListCount?.data?.collected && (
                            <Typography regular variant="h6">
                              {abbreviateNumber(collectionListCount?.data?.collected)}
                            </Typography>
                          )}
                        </>
                      )
                    }
                  </Button>
                )}
              </Grid>

              {/* Below buttons */}

              {surgeryClick && (
                <Box className={classes.rsBackSurgery}>
                  <HtmlTooltipMain
                    title="Back to Surgery"
                    className="hoverAlign"
                  >
                    <IconButton
                      className={clsx("btn_green", classes.rsButtonFromSurgery)}
                      variant="contained"
                      color="primary"
                      // startIcon={
                      //   <PrimaryIcon
                      //     icon={ArrowBackIosNewIcon}
                      //     color="white"
                      //     width="16px"
                      //     height="16px"
                      //   />
                      // }
                      onClick={() => {
                        navigate(`/surgery`);
                        setSurgeryClick(false);
                        setLocalStorage("collectionModule", true);
                      }}
                    >
                      <PrimaryIcon
                        icon={ArrowBackIosNewIcon}
                        color="white"
                        width="16px"
                        height="16px"
                      />
                    </IconButton>
                  </HtmlTooltipMain>
                </Box>
              )}
            </Box>
          )}

          <Grid className={classes.collapseAdd}>
            <Grid
              className={
                // archive
                //   ? classes.rsCollectionHeaderArchive
                //   :
                classes.rsCollectionHeader
              }
              container
            >
              {width <= 1350 &&
                width >= 1300 &&
                showDataBasedOnRole === "user" &&
                collectedUncollectedListShow === "un_collected" && (
                  <span>
                    <Select
                      value={orderDayfilter}
                      className={classes.dayAutocomplete}
                      onChange={handleSelectOrderDay}
                      sx={{
                        height: 40,
                      }}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        getContentAnchorEl: null,
                      }}
                    >
                      {orderDayMenuItems.map((name) => (
                        <MenuItem
                          key={name.index}
                          value={name.lable}
                          onClick={() => {
                            setOrderDayValue(name.value);
                            if (showDataBasedOnRole === "user") {
                              getList({
                                after_order_date_hour: name.value,
                              });
                            }
                          }}
                        >
                          {name.lable}
                        </MenuItem>
                      ))}
                    </Select>
                  </span>
                )}
              {/* {width > 1650 && (
                <SurgeryAutoComplete
                  fullWidth
                  multiple
                  maxValue={maxValue}
                  surgeryListFlag={surgeryListFlag}
                  className={clsx(
                    "autoCompleteBox",
                    classes.rsSurgeryAutoCompleteWebOther
                  )}
                  value={changeSurgeryDropDownValue}
                  handleChange={(value) => handleSurgeryChange(value)}
                  renderInput={(params) => (
                    <TextField {...params} label="Surgeries" />      
                  )}
                />
              )}

              {width > 1350 && (
                <GroupAutoComplete
                  fullWidth
                  multiple
                  className={clsx(
                    "autoCompleteBox",
                    classes.rsSurgeryAutoComplete
                  )}
                  maxValue={maxValue}
                  groupListFlag={groupListFlag}
                  value={changeGroupDropDownValue}
                  handleChange={(value) => handleGroupChange(value)}
                  renderInput={(params) => (
                    <TextField {...params} label="Group List" />
                  )}
                />
              )} */}
              {/* <Box 
                className={classes.rsiconBtn}
              >
                <FilterListIcon
                // onClick={() => handleIconFilterChange()}
                />
              </Box> */}

              {width > 1300 && (
                <TextField
                  withPadding={true}
                  medium
                  secondary
                  className="rsSearchBox"
                  placeholder="Search..."
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e?.target?.value);
                    handleSearch(e?.target?.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <>
                        <InputAdornment position="end">
                          <PrimaryIcon width="20px" icon={SearchIcon} />
                        </InputAdornment>
                      </>
                    ),
                  }}
                />
              )}

              {width > 1300 &&
                collectedUncollectedListShow === "un_collected" && (
                  <>
                    <HtmlTooltipMain
                      title="Archive"
                      className={classes.tooltip}
                    >
                      <Box className={classes.rsarchiveButton}>
                        <Button
                          // className="btn_green"
                          variant={archive ? "contained" : "outlined"}
                          color="primary"
                          className={
                            archive
                              ? classes.rsArchiveIconWeb
                              : classes.rsArchiveIconWebOutline
                          }
                          onClick={() => {
                            handleArchiveFilter();
                          }}
                        >
                          <PrimaryIcon
                            icon={ArchiveIcon}
                            // color={archive ? "white" : "primary"}
                            color="white"
                            width="25px"
                            height="25px"
                          />
                        </Button>
                      </Box>
                    </HtmlTooltipMain>
                  </>
                )}

              {width > 1300 && (
                <>
                  <Box className={classes.rsiconBtn}>
                    {/* <IconButton>
                  <FilterListIcon />
                </IconButton> */}
                    <Box>
                      <IconButton onClick={handleClickFilter}>
                        <FilterListIcon />
                        <Box paddingRight={"3px"}>
                          {" "}
                          {filterCount > 0 && filterCount}
                        </Box>
                        Filter
                      </IconButton>
                      {filterCount > 0 && (
                        <IconButton onClick={handleClickFilterClear}>
                          <ModalCloseIcon />
                        </IconButton>
                      )}
                    </Box>
                    <Menu
                      id="long-menu"
                      MenuListProps={{
                        "aria-labelledby": "long-button",
                      }}
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleCloseFilter}
                      PaperProps={{
                        style: {
                          marginTop: "12px",
                          padding: "10px",
                          // maxHeight: ITEM_HEIGHT * 4.5,
                          width: "32ch",
                        },
                      }}
                    >
                      <li
                        className={classes.rsCursor}
                        onClick={() => handleSurgeryopen()}
                      >
                        <Box className={classes.rsListAlignment}>
                          <Box>
                            Surgeries
                            {Object.keys(changeSurgeryDropDownValue).length !==
                              0 && <Box className={classes.rsActiveBtn}></Box>}
                          </Box>
                          <PrimaryIcon
                            width="20px"
                            height="20px"
                            icon={
                              surgeryOpen
                                ? KeyboardArrowUpOutlinedIcon
                                : KeyboardArrowDownOutlinedIcon
                            }
                          />
                        </Box>
                      </li>
                      <Collapse in={surgeryOpen}>
                        <ul className={classes.rsWaringFilterlistview}>
                          <li>
                            <SurgeryAutoComplete
                              fullWidth
                              multiple
                              maxValue={maxValue}
                              surgeryListFlag={surgeryListFlag}
                              className={clsx(
                                "autoCompleteBox",
                                classes.rsSurgeryAutoCompleteWebOther
                              )}
                              value={changeSurgeryDropDownValue}
                              handleChange={(value) =>
                                handleSurgeryChange(value)
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Search Surgery"
                                />
                              )}
                            />
                          </li>
                        </ul>
                      </Collapse>

                      <hr />
                      <li
                        className={classes.rsCursor}
                        onClick={() => handleGroupopen()}
                      >
                        <Box className={classes.rsListAlignment}>
                          <Box>
                            Group List
                            {Object.keys(changeGroupDropDownValue).length !==
                              0 && <Box className={classes.rsActiveBtn}></Box>}
                          </Box>
                          <PrimaryIcon
                            width="20px"
                            height="20px"
                            icon={
                              groupOpen
                                ? KeyboardArrowUpOutlinedIcon
                                : KeyboardArrowDownOutlinedIcon
                            }
                          />
                        </Box>
                      </li>
                      <Collapse in={groupOpen}>
                        <ul className={classes.rsWaringFilterlistview}>
                          <li>
                            <GroupAutoComplete
                              fullWidth
                              multiple
                              className={clsx(
                                "autoCompleteBox",
                                classes.rsSurgeryAutoComplete
                              )}
                              maxValue={maxValue}
                              groupListFlag={groupListFlag}
                              value={changeGroupDropDownValue}
                              handleChange={(value) => handleGroupChange(value)}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Search Group"
                                />
                              )}
                            />
                          </li>
                        </ul>
                      </Collapse>

                      <hr />
                      <li className={classes.customMenuItem} disableRipple>
                        <Box
                          display={width > 600 ? "flex" : "block"}
                          alignItems={"center"}
                          justifyContent={"space-around"}
                        >
                          {!archive &&
                            collectedUncollectedListShow === "un_collected" && (
                              <FormGroup>
                                <FormControlLabel
                                  className={
                                    checkedChaseUp
                                      ? classes.rsChaseUpIcon
                                      : classes.diactiveChaseup
                                  }
                                  control={
                                    <Checkbox
                                      checkedIcon={<CheckIcon />}
                                      className={
                                        checkedChaseUp ? "chaseup_effect" : ""
                                      }
                                      color="secondary"
                                      checked={checkedChaseUp}
                                      onChange={handleSelectChaseUp}
                                    />
                                  }
                                  label={`Chase Up  ${collectionListCount?.data?.chase_up
                                    ? `(${abbreviateNumber(
                                      collectionListCount?.data?.chase_up
                                    )})`
                                    : ""
                                    }`}
                                />
                              </FormGroup>
                            )}
                          {!archive &&
                            collectedUncollectedListShow === "un_collected" && (
                              <FormGroup>
                                <FormControlLabel
                                  className={
                                    urgentFilter
                                      ? classes.rsChaseUpIcon
                                      : classes.diactiveChaseup
                                  }
                                  control={
                                    <Checkbox
                                      checkedIcon={<CheckIcon />}
                                      className={
                                        urgentFilter ? "chaseup_effect" : ""
                                      }
                                      color="secondary"
                                      checked={urgentFilter}
                                      onChange={() => {
                                        if (urgentFilter) {
                                          setFilterCount(
                                            (prevCount) => prevCount - 1
                                          );
                                        }
                                        if (!urgentFilter) {
                                          setFilterCount(
                                            (prevCount) => prevCount + 1
                                          );
                                        }
                                        setUrgentFilter(!urgentFilter);
                                        let payLoad = {};
                                        payLoad.is_urgent = !urgentFilter;
                                        getList(payLoad);
                                      }}
                                    />
                                  }
                                  label={`Urgent`}
                                />
                              </FormGroup>
                            )}
                        </Box>
                      </li>
                      {/* {options.map((option) => (
          <MenuItem key={option} selected={option === 'Pyxis'} onClick={handleClose}>
            {option}
          </MenuItem>
        ))} */}
                    </Menu>
                  </Box>
                  <HtmlTooltipMain title="Print" className={classes.tooltip}>
                    <Box className={classes.rsprintButton}>
                      <Button
                        // className="btn_green"
                        variant="contained"
                        color="primary"
                        className={classes.printButton}
                        disabled={printCollectionList?.loading}
                        startIcon={
                          printCollectionList?.isLoading && (
                            <CircularProgress
                              size="20px"
                              className="rsCircularIcon"
                            />
                          )
                        }
                        onClick={() => {
                          handleGetCollectionPrintData();
                        }}
                      >
                        <PrimaryIcon
                          icon={PrintIcon}
                          color="white"
                          width="25px"
                          height="25px"
                        />
                      </Button>
                    </Box>
                  </HtmlTooltipMain>
                  <Box
                    className="ColumnMain"
                    onClick={(e) => {
                      setColumnsPopperAnchorEl(e.currentTarget);
                      if (
                        ["pharmacist_staff", "pharmacy"].indexOf(
                          showDataBasedOnRole
                        ) !== -1
                      ) {
                        setCollationActionType("collectedPharmacyAction");
                      } else {
                        setCollationActionType("CollectedAction");
                      }
                      if (collectedUncollectedListShow == "un_collected") {
                        setOpenTableColumn(true);
                      } else {
                        setOpenTableColumnCollected(true);
                      }
                    }}
                  >
                    <HtmlTooltip title="Columns">
                      <Box>
                        <Button
                          className="ColumnBtn"
                        // onClick={() => {
                        //   if (
                        //     ["pharmacist_staff", "pharmacy"].indexOf(
                        //       showDataBasedOnRole
                        //     ) !== -1
                        //   ) {
                        //     setCollationActionType("collectedPharmacyAction");
                        //   } else {
                        //     setCollationActionType("CollectedAction");
                        //   }
                        //   if (
                        //     collectedUncollectedListShow == "un_collected"
                        //   ) {
                        //     setOpenTableColumn(true);
                        //   } else {
                        //     setOpenTableColumnCollected(true);
                        //   }
                        // }}
                        >
                          <PrimaryIcon
                            color="black"
                            width="20px"
                            icon={ViewWeekIcon}
                            cursor="pointer"
                          />
                          Columns
                          <PrimaryIcon
                            color="black"
                            width="30px"
                            icon={ArrowDropDownIcon}
                            cursor="pointer"
                          />
                        </Button>
                      </Box>
                    </HtmlTooltip>
                  </Box>
                </>
              )}

              {/* RESPONSIVE */}

              {width <= 1300 && width > 408 && (
                <>
                  <Grid display={"flex"}>
                    {/* <Box className={classes.rsiconBtn}>
                      <Box>
                        <IconButton onClick={handleClickFilter}>
                          <FilterListIcon />
                          <Box paddingRight={"3px"}>
                            {" "}
                            {filterCount > 0 && filterCount}
                          </Box>
                          Filter
                        </IconButton>
                        {filterCount > 0 && (
                          <IconButton onClick={handleClickFilterClear}>
                            <ModalCloseIcon />
                          </IconButton>
                        )}
                      </Box>
                      <Menu
                        id="long-menu"
                        MenuListProps={{
                          "aria-labelledby": "long-button",
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleCloseFilter}
                        PaperProps={{
                          style: {
                            marginTop: "12px",
                            padding: "10px",
                            width: "32ch",
                          },
                        }}
                      >
                        <li
                          className={classes.rsCursor}
                          onClick={() => handleSurgeryopen()}
                        >
                          <Box className={classes.rsListAlignment}>
                            <Box>
                              Surgeries
                              {Object.keys(changeSurgeryDropDownValue)
                                .length !== 0 && (
                                <Box className={classes.rsActiveBtn}></Box>
                              )}
                            </Box>
                            <PrimaryIcon
                              width="20px"
                              height="20px"
                              icon={
                                surgeryOpen
                                  ? KeyboardArrowUpOutlinedIcon
                                  : KeyboardArrowDownOutlinedIcon
                              }
                            />
                          </Box>
                        </li>
                        <Collapse in={surgeryOpen}>
                          <ul className={classes.rsWaringFilterlistview}>
                            <li>
                              <SurgeryAutoComplete
                                fullWidth
                                multiple
                                maxValue={maxValue}
                                surgeryListFlag={surgeryListFlag}
                                className={clsx(
                                  "autoCompleteBox",
                                  classes.rsSurgeryAutoCompleteWebOther
                                )}
                                value={changeSurgeryDropDownValue}
                                handleChange={(value) =>
                                  handleSurgeryChange(value)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Search Surgery"
                                  />
                                )}
                              />
                            </li>
                          </ul>
                        </Collapse>

                        <hr />
                        <li
                          className={classes.rsCursor}
                          onClick={() => handleGroupopen()}
                        >
                          <Box className={classes.rsListAlignment}>
                            <Box>
                              Group List
                              {Object.keys(changeGroupDropDownValue).length !==
                                0 && (
                                <Box className={classes.rsActiveBtn}></Box>
                              )}
                            </Box>
                            <PrimaryIcon
                              width="20px"
                              height="20px"
                              icon={
                                groupOpen
                                  ? KeyboardArrowUpOutlinedIcon
                                  : KeyboardArrowDownOutlinedIcon
                              }
                            />
                          </Box>
                        </li>
                        <Collapse in={groupOpen}>
                          <ul className={classes.rsWaringFilterlistview}>
                            <li>
                              <GroupAutoComplete
                                fullWidth
                                multiple
                                className={clsx(
                                  "autoCompleteBox",
                                  classes.rsSurgeryAutoComplete
                                )}
                                maxValue={maxValue}
                                groupListFlag={groupListFlag}
                                value={changeGroupDropDownValue}
                                handleChange={(value) =>
                                  handleGroupChange(value)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Search Group"
                                  />
                                )}
                              />
                            </li>
                          </ul>
                        </Collapse>

                        <hr />
                        <li className={classes.customMenuItem} disableRipple>
                          <Box
                            display={width > 600 ? "flex" : "block"}
                            alignItems={"center"}
                            justifyContent={"space-around"}
                          >
                            {!archive &&
                              collectedUncollectedListShow ===
                                "un_collected" && (
                                <FormGroup>
                                  <FormControlLabel
                                    className={
                                      checkedChaseUp
                                        ? classes.rsChaseUpIcon
                                        : classes.diactiveChaseup
                                    }
                                    control={
                                      <Checkbox
                                        checkedIcon={<CheckIcon />}
                                        className={
                                          checkedChaseUp ? "chaseup_effect" : ""
                                        }
                                        color="secondary"
                                        checked={checkedChaseUp}
                                        onChange={handleSelectChaseUp}
                                      />
                                    }
                                    label={`Chase Up ${
                                      collectionListCount?.data?.chase_up
                                        ? `(${abbreviateNumber(
                                            collectionListCount?.data?.chase_up
                                          )})`
                                        : ""
                                    }`}
                                  />
                                </FormGroup>
                              )}
                            {!archive &&
                              collectedUncollectedListShow ===
                                "un_collected" && (
                                <FormGroup>
                                  <FormControlLabel
                                    className={
                                      urgentFilter
                                        ? classes.rsChaseUpIcon
                                        : classes.diactiveChaseup
                                    }
                                    control={
                                      <Checkbox
                                        checkedIcon={<CheckIcon />}
                                        className={
                                          urgentFilter ? "chaseup_effect" : ""
                                        }
                                        color="secondary"
                                        checked={urgentFilter}
                                        onChange={() => {
                                          if (urgentFilter) {
                                            setFilterCount(
                                              (prevCount) => prevCount - 1
                                            );
                                          }
                                          if (!urgentFilter) {
                                            setFilterCount(
                                              (prevCount) => prevCount + 1
                                            );
                                          }
                                          setUrgentFilter(!urgentFilter);
                                          let payLoad = {};
                                          payLoad.is_urgent = !urgentFilter;
                                          getList(payLoad);
                                        }}
                                      />
                                    }
                                    label={`Urgent`}
                                  />
                                </FormGroup>
                              )}
                          </Box>
                        </li>
                      </  
                    </Box> */}
                    <Box
                      className="ColumnMain"
                      onClick={(e) => {
                        setColumnsPopperAnchorEl(e.currentTarget);
                        if (
                          ["pharmacist_staff", "pharmacy"].indexOf(
                            showDataBasedOnRole
                          ) !== -1
                        ) {
                          setCollationActionType("collectedPharmacyAction");
                        } else {
                          setCollationActionType("CollectedAction");
                        }
                        if (collectedUncollectedListShow == "un_collected") {
                          setOpenTableColumn(true);
                        } else {
                          setOpenTableColumnCollected(true);
                        }
                      }}
                    >
                      <HtmlTooltip title="Columns">
                        <Box>
                          <Button
                            className="ColumnBtn"
                          // onClick={() => {
                          //   if (
                          //     ["pharmacist_staff", "pharmacy"].indexOf(
                          //       showDataBasedOnRole
                          //     ) !== -1
                          //   ) {
                          //     setCollationActionType(
                          //       "collectedPharmacyAction"
                          //     );
                          //   } else {
                          //     setCollationActionType("CollectedAction");
                          //   }
                          //   if (
                          //     collectedUncollectedListShow == "un_collected"
                          //   ) {
                          //     setOpenTableColumn(true);
                          //   } else {
                          //     setOpenTableColumnCollected(true);
                          //   }
                          // }}
                          >
                            <PrimaryIcon
                              color="black"
                              width="20px"
                              icon={ViewWeekIcon}
                              cursor="pointer"
                            />
                            Columns
                            <PrimaryIcon
                              color="black"
                              width="30px"
                              icon={ArrowDropDownIcon}
                              cursor="pointer"
                            />
                          </Button>
                        </Box>
                      </HtmlTooltip>
                    </Box>
                  </Grid>

                  <Box display={"flex"} marginRight={"11px"}>
                    {surgeryClick && width > 560 && (
                      <Box className={classes.rsBackSurgery}>
                        <Button
                          children="Back to Surgery"
                          variant="contained"
                          color="primary"
                          startIcon={
                            <PrimaryIcon
                              icon={ArrowBackIosNewIcon}
                              color="white"
                              width="16px"
                              height="16px"
                            />
                          }
                          onClick={() => {
                            navigate(`/surgery`);
                            setSurgeryClick(false);
                            setLocalStorage("collectionModule", true);
                          }}
                        />
                      </Box>
                    )}
                    <HtmlTooltip title="Filter">
                      <Box className={classes.rsFilterIconUnCollectedOther}>
                        <Button
                          // className={classes.rsFilterIconUnCollectedOther}
                          variant="outlined"
                          onClick={() => {
                            setOpenFilterPopup(true);
                          }}
                        >
                          <PrimaryIcon
                            color="primary"
                            width="20px"
                            height="37px"
                            icon={FilterIcon}
                          />
                        </Button>
                      </Box>
                    </HtmlTooltip>
                    <HtmlTooltipMain title="Print" className={classes.tooltip}>
                      <Box className={classes.rsprintButton}>
                        <Button
                          // className="btn_green"
                          variant="outlined"
                          color="primary"
                          className={classes.printButton}
                          disabled={printCollectionList?.loading}
                          startIcon={
                            printCollectionList?.isLoading && (
                              <CircularProgress
                                size="20px"
                                className="rsCircularIcon"
                              />
                            )
                          }
                          onClick={() => {
                            handleGetCollectionPrintData();
                          }}
                        >
                          <PrimaryIcon
                            icon={PrintIcon}
                            color="white"
                            width="25px"
                            height="25px"
                          />
                        </Button>
                      </Box>
                    </HtmlTooltipMain>

                    {collectedUncollectedListShow === "un_collected" && (
                      <>
                        <HtmlTooltipMain
                          title="Archive"
                          className={classes.tooltip}
                        >
                          <Box className={classes.rsprintButton}>
                            <Button
                              // className="btn_green"
                              variant={archive ? "contained" : "outlined"}
                              color="primary"
                              className={
                                archive
                                  ? classes.rsArchiveIconWeb
                                  : classes.rsArchiveIconWebOutline
                              }
                              onClick={() => {
                                handleArchiveFilter();
                              }}
                            >
                              <PrimaryIcon
                                icon={ArchiveIcon}
                                // color={archive ? "white" : "primary"}
                                color="white"
                                width="25px"
                                height="25px"
                              />
                            </Button>
                          </Box>
                        </HtmlTooltipMain>
                      </>
                    )}
                  </Box>
                </>
              )}

              {width <= 408 && (
                <Grid container className={classes.mobileHeader}>
                  <Grid container>
                    {collectedUncollectedListShow === "un_collected" && (
                      <HtmlTooltipMain title="Add RX" className="hoverAlign">
                        <Button
                          variant="contained"
                          className={classes.rsButtonHowtoIcon}
                          startIcon={
                            <PrimaryIcon
                              icon={AddIcon}
                              color="white"
                              width="16px"
                              height="16px"
                            />
                          }
                          onClick={() => {
                            navigate(`${location.pathname}?actionType=createNewRx`);
                          }}
                        >
                          Add Rx
                        </Button>
                      </HtmlTooltipMain>
                    )}
                    <Box
                      className="ColumnMain"
                      onClick={(e) => {
                        setColumnsPopperAnchorEl(e.currentTarget);
                        if (
                          ["pharmacist_staff", "pharmacy"].indexOf(
                            showDataBasedOnRole
                          ) !== -1
                        ) {
                          setCollationActionType("collectedPharmacyAction");
                        } else {
                          setCollationActionType("CollectedAction");
                        }
                        if (collectedUncollectedListShow == "un_collected") {
                          setOpenTableColumn(true);
                        } else {
                          setOpenTableColumnCollected(true);
                        }
                      }}
                    >
                      <HtmlTooltip title="Columns">
                        <Box>
                          <Button
                            className="ColumnBtn"
                          // onClick={() => {
                          //   if (
                          //     ["pharmacist_staff", "pharmacy"].indexOf(
                          //       showDataBasedOnRole
                          //     ) !== -1
                          //   ) {
                          //     setCollationActionType(
                          //       "collectedPharmacyAction"
                          //     );
                          //   } else {
                          //     setCollationActionType("CollectedAction");
                          //   }
                          //   if (
                          //     collectedUncollectedListShow == "un_collected"
                          //   ) {
                          //     setOpenTableColumn(true);
                          //   } else {
                          //     setOpenTableColumnCollected(true);
                          //   }
                          // }}
                          >
                            <PrimaryIcon
                              color="black"
                              width="20px"
                              icon={ViewWeekIcon}
                              cursor="pointer"
                            />
                            Columns
                            <PrimaryIcon
                              color="black"
                              width="30px"
                              icon={ArrowDropDownIcon}
                              cursor="pointer"
                            />
                          </Button>
                        </Box>
                      </HtmlTooltip>
                    </Box>
                  </Grid>

                  <Grid container>
                    <Box className={classes.rsiconBtn}>
                      <Box>
                        <IconButton onClick={handleClickFilter}>
                          <FilterListIcon />
                          <Box paddingRight={"3px"}>
                            {" "}
                            {filterCount > 0 && filterCount}
                          </Box>
                          Filter
                        </IconButton>
                        {filterCount > 0 && (
                          <IconButton onClick={handleClickFilterClear}>
                            <ModalCloseIcon />
                          </IconButton>
                        )}
                      </Box>
                      <Menu
                        id="long-menu"
                        MenuListProps={{
                          "aria-labelledby": "long-button",
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleCloseFilter}
                        PaperProps={{
                          style: {
                            marginTop: "12px",
                            padding: "10px",
                            // maxHeight: ITEM_HEIGHT * 4.5,
                            width: "32ch",
                          },
                        }}
                      >
                        <li
                          className={classes.rsCursor}
                          onClick={() => handleSurgeryopen()}
                        >
                          <Box className={classes.rsListAlignment}>
                            <Box>
                              Surgeries
                              {Object.keys(changeSurgeryDropDownValue)
                                .length !== 0 && (
                                  <Box className={classes.rsActiveBtn}></Box>
                                )}
                            </Box>
                            <PrimaryIcon
                              width="20px"
                              height="20px"
                              icon={
                                surgeryOpen
                                  ? KeyboardArrowUpOutlinedIcon
                                  : KeyboardArrowDownOutlinedIcon
                              }
                            />
                          </Box>
                        </li>
                        <Collapse in={surgeryOpen}>
                          <ul className={classes.rsWaringFilterlistview}>
                            <li>
                              <SurgeryAutoComplete
                                fullWidth
                                multiple
                                maxValue={maxValue}
                                surgeryListFlag={surgeryListFlag}
                                className={clsx(
                                  "autoCompleteBox",
                                  classes.rsSurgeryAutoCompleteWebOther
                                )}
                                value={changeSurgeryDropDownValue}
                                handleChange={(value) =>
                                  handleSurgeryChange(value)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Search Surgery"
                                  />
                                )}
                              />
                            </li>
                          </ul>
                        </Collapse>

                        <hr />
                        <li
                          className={classes.rsCursor}
                          onClick={() => handleGroupopen()}
                        >
                          <Box className={classes.rsListAlignment}>
                            <Box>
                              Group List
                              {Object.keys(changeGroupDropDownValue).length !==
                                0 && (
                                  <Box className={classes.rsActiveBtn}></Box>
                                )}
                            </Box>
                            <PrimaryIcon
                              width="20px"
                              height="20px"
                              icon={
                                groupOpen
                                  ? KeyboardArrowUpOutlinedIcon
                                  : KeyboardArrowDownOutlinedIcon
                              }
                            />
                          </Box>
                        </li>
                        <Collapse in={groupOpen}>
                          <ul className={classes.rsWaringFilterlistview}>
                            <li>
                              <GroupAutoComplete
                                fullWidth
                                multiple
                                className={clsx(
                                  "autoCompleteBox",
                                  classes.rsSurgeryAutoComplete
                                )}
                                maxValue={maxValue}
                                groupListFlag={groupListFlag}
                                value={changeGroupDropDownValue}
                                handleChange={(value) =>
                                  handleGroupChange(value)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Search Group"
                                  />
                                )}
                              />
                            </li>
                          </ul>
                        </Collapse>

                        <hr />
                        <li className={classes.customMenuItem} disableRipple>
                          <Box
                            display={width > 600 ? "flex" : "block"}
                            alignItems={"center"}
                            justifyContent={"space-around"}
                          >
                            {!archive &&
                              collectedUncollectedListShow ===
                              "un_collected" && (
                                <FormGroup>
                                  <FormControlLabel
                                    className={
                                      checkedChaseUp
                                        ? classes.rsChaseUpIcon
                                        : classes.diactiveChaseup
                                    }
                                    control={
                                      <Checkbox
                                        checkedIcon={<CheckIcon />}
                                        className={
                                          checkedChaseUp ? "chaseup_effect" : ""
                                        }
                                        color="secondary"
                                        checked={checkedChaseUp}
                                        onChange={handleSelectChaseUp}
                                      />
                                    }
                                    label={`Chase Up ${collectionListCount?.data?.chase_up
                                      ? `(${abbreviateNumber(
                                        collectionListCount?.data?.chase_up
                                      )})`
                                      : ""
                                      }`}
                                  />
                                </FormGroup>
                              )}
                            {!archive &&
                              collectedUncollectedListShow ===
                              "un_collected" && (
                                <FormGroup>
                                  <FormControlLabel
                                    className={
                                      urgentFilter
                                        ? classes.rsChaseUpIcon
                                        : classes.diactiveChaseup
                                    }
                                    control={
                                      <Checkbox
                                        checkedIcon={<CheckIcon />}
                                        className={
                                          urgentFilter ? "chaseup_effect" : ""
                                        }
                                        color="secondary"
                                        checked={urgentFilter}
                                        onChange={() => {
                                          if (urgentFilter) {
                                            setFilterCount(
                                              (prevCount) => prevCount - 1
                                            );
                                          }
                                          if (!urgentFilter) {
                                            setFilterCount(
                                              (prevCount) => prevCount + 1
                                            );
                                          }
                                          setUrgentFilter(!urgentFilter);
                                          let payLoad = {};
                                          payLoad.is_urgent = !urgentFilter;
                                          getList(payLoad);
                                        }}
                                      />
                                    }
                                    label={`Urgent`}
                                  />
                                </FormGroup>
                              )}
                          </Box>
                        </li>
                      </Menu>
                    </Box>
                    <Box display={"flex"} marginRight={"11px"}>
                      {surgeryClick && width > 560 && (
                        <Box className={classes.rsBackSurgery}>
                          <Button
                            children="Back to Surgery"
                            variant="contained"
                            color="primary"
                            startIcon={
                              <PrimaryIcon
                                icon={ArrowBackIosNewIcon}
                                color="white"
                                width="16px"
                                height="16px"
                              />
                            }
                            onClick={() => {
                              navigate(`/surgery`);
                              setSurgeryClick(false);
                              setLocalStorage("collectionModule", true);
                            }}
                          />
                        </Box>
                      )}
                      <HtmlTooltip title="Filter">
                        <Box className={classes.rsFilterIconUnCollectedOther}>
                          <Button
                            // className={classes.rsFilterIconUnCollectedOther}
                            variant="outlined"
                            onClick={() => {
                              setOpenFilterPopup(true);
                            }}
                          >
                            <PrimaryIcon
                              color="primary"
                              width="20px"
                              height="37px"
                              icon={FilterIcon}
                            />
                          </Button>
                        </Box>
                      </HtmlTooltip>
                      <HtmlTooltipMain
                        title="Print"
                        className={classes.tooltip}
                      >
                        <Box className={classes.rsprintButton}>
                          <Button
                            // className="btn_green"
                            variant="outlined"
                            color="primary"
                            className={classes.printButton}
                            disabled={printCollectionList?.loading}
                            startIcon={
                              printCollectionList?.isLoading && (
                                <CircularProgress
                                  size="20px"
                                  className="rsCircularIcon"
                                />
                              )
                            }
                            onClick={() => {
                              handleGetCollectionPrintData();
                            }}
                          >
                            <PrimaryIcon
                              icon={PrintIcon}
                              color="white"
                              width="25px"
                              height="25px"
                            />
                          </Button>
                        </Box>
                      </HtmlTooltipMain>

                      {collectedUncollectedListShow === "un_collected" && (
                        <>
                          <HtmlTooltipMain
                            title="Archive"
                            className={classes.tooltip}
                          >
                            <Box className={classes.rsprintButton}>
                              <Button
                                // className="btn_green"
                                variant={archive ? "contained" : "outlined"}
                                color="primary"
                                className={
                                  archive
                                    ? classes.rsArchiveIconWeb
                                    : classes.rsArchiveIconWebOutline
                                }
                                onClick={() => {
                                  handleArchiveFilter();
                                }}
                              >
                                <PrimaryIcon
                                  icon={ArchiveIcon}
                                  // color={archive ? "white" : "primary"}
                                  color="white"
                                  width="25px"
                                  height="25px"
                                />
                              </Button>
                            </Box>
                          </HtmlTooltipMain>
                        </>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Box className={clsx(classes.rsCollapseContainer, "collapseListView")}>
          {/* {collectedUncollectedListShow === "un_collected" && ( */}
          <Grid
            className={
              surgeryClick
                ? classes.gridRow
                : showDataBasedOnRole === "user"
                  ? classes.gridRow
                  : width <= 1650
                    ? classes.gridRow
                    : classes.gridNotSurgey
            }
          >
            {/* <Box
              display={width > 600 ? "flex" : "block"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {!archive && collectedUncollectedListShow === "un_collected" && (
                <FormGroup>
                  <FormControlLabel
                    className={
                      checkedChaseUp
                        ? classes.rsChaseUpIcon
                        : classes.diactiveChaseup
                    }
                    control={
                      <Checkbox
                        checkedIcon={<CheckIcon />}
                        className={checkedChaseUp ? "chaseup_effect" : ""}
                        color="secondary"
                        checked={checkedChaseUp}
                        onChange={handleSelectChaseUp}
                      />
                    }
                    label={`Chase Up ${
                      collectionListCount?.data?.chase_up
                        ? `(${abbreviateNumber(
                            collectionListCount?.data?.chase_up
                          )})`
                        : ""
                    }`}
                  />
                </FormGroup>
              )}
              {!archive && collectedUncollectedListShow === "un_collected" && (
                <FormGroup>
                  <FormControlLabel
                    className={
                      urgentFilter
                        ? classes.rsChaseUpIcon
                        : classes.diactiveChaseup
                    }
                    control={
                      <Checkbox
                        checkedIcon={<CheckIcon />}
                        className={urgentFilter ? "chaseup_effect" : ""}
                        color="secondary"
                        checked={urgentFilter}
                        onChange={() => {
                          setUrgentFilter(!urgentFilter);
                          let payLoad = {};
                          payLoad.is_urgent = !urgentFilter;
                          getList(payLoad);
                        }}
                      />
                    }
                    label={`Urgent`}
                  />
                </FormGroup>
              )}
            </Box> */}
            {width > 1300 && (
              <Box display={"flex"}>
                {/* {width <= 1350 && (
                  <GroupAutoComplete
                    fullWidth
                    multiple
                    className={clsx(
                      "autoCompleteBox",
                      classes.rsSurgeryAutoComplete
                    )}
                    maxValue={maxValue}
                    groupListFlag={groupListFlag}
                    value={changeGroupDropDownValue}
                    handleChange={(value) => handleGroupChange(value)}
                    renderInput={(params) => (
                      <TextField {...params} label="Group List" />
                    )}
                  />
                )}
                {width <= 1650 && (
                  <SurgeryAutoComplete
                    fullWidth
                    multiple
                    maxValue={maxValue}
                    surgeryListFlag={surgeryListFlag}
                    className={clsx(
                      "autoCompleteBox",
                      classes.rsSurgeryAutoCompleteWebOther
                    )}
                    value={changeSurgeryDropDownValue}
                    handleChange={(value) => handleSurgeryChange(value)}
                    renderInput={(params) => (
                      <TextField {...params} label="Surgeries" />
                    )}
                  />
                )} */}
                {/* {surgeryClick && (
                  <Box className={classes.rsBackSurgery}>
                    <Button
                      children="Back to Surgery"
                      variant="contained"
                      color="primary"
                      startIcon={
                        <PrimaryIcon
                          icon={ArrowBackIosNewIcon}
                          color="white"
                          width="16px"
                          height="16px"
                        />
                      }
                      onClick={() => {
                        navigate(`/surgery`);
                        setSurgeryClick(false);
                        setLocalStorage("collectionModule", true);
                      }}
                    />
                  </Box>
                )} */}
                {width > 1350 &&
                  showDataBasedOnRole === "user" &&
                  collectedUncollectedListShow === "un_collected" &&
                  orderDayValue !== "" && (
                    <>
                      <span>
                        <Select
                          value={orderDayfilter}
                          className={classes.dayAutocomplete}
                          onChange={handleSelectOrderDay}
                          sx={{
                            height: 40,
                          }}
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                            getContentAnchorEl: null,
                          }}
                        >
                          {orderDayMenuItems.map((name) => (
                            <MenuItem
                              key={name.index}
                              value={name.lable}
                              onClick={() => {
                                setOrderDayValue(name.value);
                                if (showDataBasedOnRole === "user") {
                                  getList({
                                    after_order_date_hour: name.value,
                                  });
                                }
                              }}
                            >
                              {name.lable}
                            </MenuItem>
                          ))}
                        </Select>
                      </span>
                    </>
                  )}
              </Box>
            )}
          </Grid>
          {surgeryClick && width <= 560 && (
            <Box className={classes.rsBackSurgery}>
              <Button
                children="Back to Surgery"
                variant="contained"
                color="primary"
                startIcon={
                  <PrimaryIcon
                    icon={ArrowBackIosNewIcon}
                    color="white"
                    width="16px"
                    height="16px"
                  />
                }
                onClick={() => {
                  navigate(`/surgery`);
                  setSurgeryClick(false);
                  setLocalStorage("collectionModule", true);
                }}
              />
            </Box>
          )}
        </Box>

        {isPrescriptionTracking && <PrescriptionTrackingBanners />}

        <Box className={classes.rsGrid}>
          {collectedUncollectedListShow === "collected" ? (
            <CollectedTable
              collectionRxList={collectionRxList}
              setDeleteCollectionDetails={setDeleteCollectionDetails}
              setCollectionDeleteId={setCollectionDeleteId}
              setTarget={setTarget}
              setIsOpenViewRx={setIsOpenViewRx}
              setCollectionActionType={setCollectionActionType}
              setCollectAndUncollectedViewRxDetails={
                setCollectAndUncollectedViewRxDetails
              }
              setOpenCollectedNoteList={setOpenCollectedNoteList}
              setShowCollectedNoteList={setShowCollectedNoteList}
              setCollectedUncollectedListShow={setCollectedUncollectedListShow}
              setSelectedNoteDetails={setSelectedNoteDetails}
              defaultColumnOrderBy={defaultColumnOrderBy}
              columnSortingOrder={columnSortingOrder}
              setColumnSortingOrder={setColumnSortingOrder}
              HtmlTooltipMain={HtmlTooltipMain}
              showDataBasedOnRole={showDataBasedOnRole}
              tableCells={collectedTableColumns}
              setIsOpenEditDobModel={setIsOpenEditDobModel}
              setEditDobDate={setEditDobDate}
              patientDetailOpen={patientDetailOpen}
              setPatientDetailOpen={setPatientDetailOpen}
              patientId={patientId}
              setPatientId={setPatientId}
              subscriptionDialog={subscriptionDialog}
              setSubscritionDialog={setSubscritionDialog}
              loginUserDetail={loginUserDetail}
              isPrescriptionTracking={isPrescriptionTracking}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          ) : (
            <UnCollectedTable
              collectionRxList={collectionRxList}
              setDeleteCollectionDetails={setDeleteCollectionDetails}
              setCollectionDeleteId={setCollectionDeleteId}
              setTarget={setTarget}
              setIsOpenViewRx={setIsOpenViewRx}
              getList={getList}
              setCollectionActionType={setCollectionActionType}
              collectedUncollectedListShow={collectedUncollectedListShow}
              collectAndUncollectedViewRxDetails={
                collectAndUncollectedViewRxDetails
              }
              setCollectAndUncollectedViewRxDetails={
                setCollectAndUncollectedViewRxDetails
              }
              setOpenCollectedNoteList={setOpenCollectedNoteList}
              setShowCollectedNoteList={setShowCollectedNoteList}
              setCollectedUncollectedListShow={setCollectedUncollectedListShow}
              collectionViewRxAction={collectionViewRxAction}
              collectionViewRxDetails={collectionViewRxDetails}
              selectedNoteDetails={selectedNoteDetails}
              setSelectedNoteDetails={setSelectedNoteDetails}
              createChaseUpDetails={createChaseUpDetails}
              UpdateChaseUp={UpdateChaseUp}
              defaultColumnOrderBy={defaultColumnOrderBy}
              columnSortingOrder={columnSortingOrder}
              setColumnSortingOrder={setColumnSortingOrder}
              chaseUpActiveStatus={checkedChaseUp}
              HtmlTooltipMain={HtmlTooltipMain}
              showDataBasedOnRole={showDataBasedOnRole}
              detailsDialog={detailsDialog}
              setDetailsDialog={setDetailsDialog}
              patientDetails={patientDetails}
              setPatientDetails={setPatientDetails}
              resetCollectionRxState={resetCollectionRxState}
              tableCells={tableColumns}
              getHomeListAction={getHomeListAction}
              setIsOpenEditDobModel={setIsOpenEditDobModel}
              setEditDobDate={setEditDobDate}
              archive={archive}
              openViewOrder={openViewOrder}
              setOpenViewOrder={setOpenViewOrder}
              openFaxOrder={openFaxOrder}
              setOpenFaxOrder={setOpenFaxOrder}
              phone={phone}
              setPhone={setPhone}
              fax={fax}
              setFax={setFax}
              setNoteId={setNoteId}
              handleDeleteNote={handleDeleteNote}
              deleteSingleNote={deleteSingleNote}
              addAndUpdateNoteAction={addAndUpdateNoteAction}
              addAndUpdateNote={addAndUpdateNote}
              getArchiveCollectionAction={getArchiveCollectionAction}
              patientDetailOpen={patientDetailOpen}
              setPatientDetailOpen={setPatientDetailOpen}
              patientId={patientId}
              setPatientId={setPatientId}
              urgentFilter={urgentFilter}
              setUrgentFilter={setUrgentFilter}
              readyToCollect={readyToCollect}
              setReadyToCollect={setReadyToCollect}
              checked={checked}
              setChecked={setChecked}
              loginUserDetail={loginUserDetail}
              subscriptionDialog={subscriptionDialog}
              setSubscritionDialog={setSubscritionDialog}
              setViewOrderData={setViewOrderData}
              isPrescriptionTracking={isPrescriptionTracking}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          )}
        </Box>
      </Grid>
      <ViewRxDialog
        open={isOpenViewRx}
        setOpen={setIsOpenViewRx}
        collectionViewRxAction={collectionViewRxAction}
        collectionViewRxDetails={collectionViewRxDetails}
        collectedUncollectedListShow={collectedUncollectedListShow}
        collectAndUncollectedViewRxDetails={collectAndUncollectedViewRxDetails}
      />
      <ViewOrderDialog
        open={openViewOrder}
        setOpen={setOpenViewOrder}
        body={collectionViewRxDetails}
        actionType={"viewRx"}
        collect
        collectionViewRxAction={collectionViewRxAction}
        collectedUncollectedListShow={collectedUncollectedListShow}
        collectAndUncollectedViewRxDetails={collectAndUncollectedViewRxDetails}
        setViewOrderData={setViewOrderDataMail}
        viewOrderData={viewOrderDataMail}
      />
      <FaxDialog
        open={openFaxOrder}
        actionType={"viewRx"}
        setOpen={setOpenFaxOrder}
        body={collectionViewRxDetails}
        phone={phone}
        setPhone={setPhone}
        fax={fax}
        setFax={setFax}
        collect
        collectionViewRxAction={collectionViewRxAction}
        collectedUncollectedListShow={collectedUncollectedListShow}
        collectAndUncollectedViewRxDetails={collectAndUncollectedViewRxDetails}
        setViewOrderData={setViewOrderData}
        viewOrderData={viewOrderData}
      />
      <ConfirmationDialog
        open={deleteCollectionDetails}
        setOpen={setDeleteCollectionDetails}
        title="Are you sure?"
        body={
          collectedUncollectedListShow === "collected"
            ? "You wan't be able to undo this collection!"
            : archive
              ? "Unarchive this collection"
              : "Archive this collection"
        }
        handleSubmit={
          collectedUncollectedListShow !== "collected"
            ? handleArchiveRepeatOrder
            : handleDeleteRepeatOrder
        }
        actionBtnTitle={
          collectedUncollectedListShow === "collected"
            ? "Yes Delete It!!"
            : archive
              ? "Yes Unarchive It!!"
              : "Yes Archive It!!"
        }
        loading={deleteCollectionRx?.loading}
      />
      <CollectionNotesDialog
        stickyHeader
        open={openCollectedNoteList}
        setOpen={setOpenCollectedNoteList}
        subTitle="NOTE DETAIL"
        commentTitle="COMMENT"
        body={showCollectedNoteList}
        actionBtnTitle="Ok"
        collectedUncollectedListShow={collectedUncollectedListShow}
        addAndUpdateNoteAction={addAndUpdateNoteAction}
        selectedNoteDetails={selectedNoteDetails}
        addAndUpdateNote={addAndUpdateNote}
        resetCollectionRxState={resetCollectionRxState}
        setNoteId={setNoteId}
        deleteNoteData={deleteNoteData}
        setDeleteNoteData={setDeleteNoteData}
        handleDeleteNote={handleDeleteNote}
        deleteSingleNote={deleteSingleNote}
        getList={getList}
        setSelectedNoteDetails={setSelectedNoteDetails}
        setShowCollectedNoteList={setShowCollectedNoteList}
        subscriptionDialog={subscriptionDialog}
        setSubscritionDialog={setSubscritionDialog}
        loginUserDetail={loginUserDetail}
      />
      <AddAndUpdateNoteDialog
        open={openNotePopup}
        setOpen={setOpenNotePopup}
        addAndUpdateNoteAction={addAndUpdateNoteAction}
        addAndUpdateNote={addAndUpdateNote}
        resetCollectionRxState={resetCollectionRxState}
        selectedNoteDetails={selectedNoteDetails}
        collectedUncollectedListShow={collectedUncollectedListShow}
      />
      {/* {globalSettingDialogStatus && ( */}
      <DaysSettingDialog
        open={globalSettingDialogStatus}
        setOpen={serGlobalSettingDialogStatus}
        onSettingSaved={function () {
          getList();
        }}
        globalSetting={globalSetting}
        updateGlobalSettingAction={updateGlobalSettingAction}
        chaseUpHrs={chaseUpHrs}
        seTChaseUpHrs={seTChaseUpHrs}
      />
      {/* )} */}
      {showPrintData === true && (
        <PrintCollection
          collectionRxList={printCollectionList}
          showPrintData={showPrintData}
          collectedUncollectedListShow={collectedUncollectedListShow}
          collectedTableColumns={collectedTableColumns}
          tableColumns={tableColumns}
          archive={archive}
        />
      )}
      <SearchAndFilterDialogCollectionMobileView
        open={openFilterPopup}
        setOpen={setOpenFilterPopup}
        maxValue={maxValue}
        surgeryListFlag={surgeryListFlag}
        changeSurgeryDropDownValue={changeSurgeryDropDownValue}
        handleSurgeryChange={handleSurgeryChange}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        handleSearch={handleSearch}
        groupListFlag={groupListFlag}
        changeGroupDropDownValue={changeGroupDropDownValue}
        handleGroupChange={handleGroupChange}
        showDataBasedOnRole={showDataBasedOnRole}
        orderDayfilter={orderDayfilter}
        handleSelectOrderDay={handleSelectOrderDay}
        orderDayMenuItems={orderDayMenuItems}
        setOrderDayValue={setOrderDayValue}
        getList={getList}
        collectedUncollectedListShow={collectedUncollectedListShow}
      />
      <InfomationDialog
        open={detailsDialog}
        setOpen={setDetailsDialog}
        patientDetails={patientDetails}
        setPatientDetails={setPatientDetails}
        type="collection"
      />
      <TableColumnShowMenu
        open={openTableColumnCollected}
        setOpen={setOpenTableColumnCollected}
        anchorEl={columnsPopperAnchorEl}
        tableColumns={collectedTableColumns}
        setTableColumns={setCollectedTableColumns}
        onOrderChange={(newOrder) => setCollectedTableColumns(newOrder)}
        tableCells={collectedTableCells}
        collationActionType={collationActionType}
        moduleName={"collected"}
      />
      <TableColumnShowMenu
        open={openTableColumn}
        setOpen={setOpenTableColumn}
        anchorEl={columnsPopperAnchorEl}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        onOrderChange={(newOrder) => setTableColumns(newOrder)}
        tableCells={unCollectedTableCells}
        collationActionType={collationActionType}
        moduleName={"unCollected"}
        isPrescriptionTracking={isPrescriptionTracking}
      />
      <EditDobDialog
        open={isOpenEditDobModel}
        setOpen={setIsOpenEditDobModel}
        editData={editDobDate}
        setEditData={setEditDobDate}
        // orderRecordActionType={orderRecordActionType}
        getList={getList}
        type="collection"
        subscriptionDialog={subscriptionDialog}
        setSubscritionDialog={setSubscritionDialog}
        loginUserDetail={loginUserDetail}
      />
      <PatientDetailDialog
        open={patientDetailOpen}
        setOpen={setPatientDetailOpen}
        patientId={patientId}
        setPatientId={setPatientId}
        getSinglePatientAction={getSinglePatientAction}
        data={singlePatientData}
        getPatientHistoryAction={getPatientHistoryAction}
        patientMedicationHistoryList={patientMedicationHistoryList}
        handleMediArchive={handleMediArchive}
        getList={getList}
      />
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscritionDialog}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  collectionRxList: state.collection.collectionRxList,
  deleteCollectionRx: state.collection.deleteCollectionRx,
  collectionListCount: state.collection.collectionListCount,
  collectionViewRxDetails: state.collection.collectionViewRxDetails,
  addAndUpdateNote: state.collection.addAndUpdateNote,
  deleteSingleNote: state.collection.deleteSingleNote,
  globalSetting: state.order.globalSetting,
  createChaseUpDetails: state.collection.createChaseUpDetails,
  printCollectionList: state.collection.printCollectionList,
  singlePatientData: state.patient.singlePatientData,
  patientMedicationHistoryList: state.patient.patientMedicationHistoryList,
  archiveMedi: state.patient.archiveMedi,
});
const mapDispatchToProps = (dispatch) => ({
  getPatientListAction: (payload) =>
    dispatch({ type: START_GET_PATIENT_LIST, payload }),
  getCollectionRxAction: (payload) =>
    dispatch({ type: START_GET_COLLECTION_LIST, payload }),
  resetCollectionRxState: (key, payload) =>
    dispatch({ type: RESET_COLLECTION_STATE, key, payload }),
  deleteCollectionRxAction: (id) =>
    dispatch({ type: START_DELETE_COLLECTION, id }),
  getCollectionCountAction: (payload) =>
    dispatch({ type: START_GET_COLLECTION_COUNT, payload }),
  collectionViewRxAction: (id, payload) =>
    dispatch({ type: START_GET_COLLECTION_DETAIL, id, payload }),
  addAndUpdateNoteAction: (id, payload) =>
    dispatch({ type: START_ADD_AND_UPDATE_NOTE, id, payload }),
  deleteNoteAction: (id, payload) =>
    dispatch({ type: START_DELETE_NOTE, id, payload }),
  updateGlobalSettingAction: (payload, actionType) =>
    dispatch({ type: START_UPDATE_GLOBAL_SETTING, payload, actionType }),
  UpdateChaseUp: (id, payload, chaseUpActiveStatus) =>
    dispatch({ type: START_CREATE_CHASEUP, id, payload, chaseUpActiveStatus }),
  getPrintCollectionListAction: (payload) =>
    dispatch({ type: START_GET_PRINT_COLLECTION_LIST, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
  getSinglePatientAction: (id) =>
    dispatch({ type: START_GET_SINGLE_PATIENT, id }),
  getPatientHistoryAction: (id, payload) =>
    dispatch({ type: START_GET_PATIENT_MEDICATION_HISTORY_LIST, id, payload }),
  getArchiveCollectionAction: (payload) =>
    dispatch({ type: START_ARCHIVE_COLLECTION, payload }),
  getMedicationArchiveAction: (id, payload, historyPayload) =>
    dispatch({ type: START_ARCHIVE_MEDICATION, id, payload, historyPayload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CollectionMain);
